<template>
  <div class="overflow-scroll-y">

    <!-- <img src="/static/renew2_img/mynabi_images/mynabi_bait_image20231108.png" usemap="#ImageMap" alt="" />
        <map name="ImageMap">
          <area shape="poly" coords="590,1371,589,1370,690,1364,692,1394,592,1398,592,1398" href="#" alt="" />
          <area shape="poly" coords="707,1364,1019,1353,1019,1383,707,1392,707,1392" href="#" alt="" />
          <area shape="poly" coords="480,1408,581,1403,582,1431,482,1434,482,1434" href="#" alt="" />
          <area shape="poly" coords="596,1403,794,1397,794,1424,598,1431,650,1439" href="#" alt="" />
          <area shape="poly" coords="284,1474,863,1452,862,1596,287,1615,286,1537" href="javascript:alert(2)" alt="" />
          <area shape="circle" coords="1080,70,39" href="#" onclick="alert(1)" alt="" />
        </map> -->
    <div class="card-header">
      <h2>目的に合わせて選ぶ</h2>
      <p v-if="false">作成した履歴書をPDFでダウンロードします。<br>メール送信、コンビニ印刷、ダウンロードボタンを押下すると自動でバックアップされます。</p>
      <p style="color:red;" v-if="!$firebase.isAuthenticated">
        ※メール送信、コンビニ印刷、ダウンロード、ヤギのメール便はログインが必須となります。<br>下記のいずれかのボタンを選択後、ログインしてください。</p>
    </div>

    <div class="card-content">
      <div class="button-download-pdf">
        <div class="bnr_container" v-if="formatId == 'internship' && false" style="padding: 0;">
          <div class="bnr_item">
            <img v-if="!isSendedYagishIntern"
              @click="$eventHub.$emit('send-yagish-intern'); isSendedYagishIntern = true;"
              src="/static/renew_img/bnr/intern_yagish_bnr_20230414.png" alt="Yagishインターン">
            <div class="bnr_txt" v-if="!isSendedYagishIntern">
              <ul style="font-size: 0.8rem; margin-left: 0;text-align: left;">
                <li>※応募するバナーをクリックすると、作成した履歴書がYagishに送付されます。</li>
                <li>※選考に進む際はこちらからご連絡いたします。</li>
                <li>※インターンに関する採用情報は<a href="https://www.yagish.jp/recruit-info/intern2023/"
                    target="_blank">こちら</a>からご確認ください。</li>
              </ul>
            </div>
            <div class="bnr_txt" v-else>
              <ul style="font-size: 0.8rem; margin-left: 0;">
                <li>履歴書が送付されました。ありがとございます</li>
              </ul>
            </div>
          </div>
        </div>

        <div v-if="$firebase.isAuthenticated && $globalVar.autoRTInfo && $globalVar.autoRTInfo.clientId" class="roxxrt_container">
          <div class="roxxrt_container__flex">
            <img :src="$globalVar.autoRTInfo.logoImage" alt="Yagish*" class="roxxrt_img">
            <p class="roxxrt_txt">
              Yagishの<router-link id="footer-link-terms" :to="{ name: 'termsPage' }"
                target="_blank">利用規約</router-link>、<router-link id="footer-link-policy" :to="{ name: 'policyPage' }"
                target="_blank">個人情報保護方針</router-link>、<a href="https://www.yagish.jp/privacy_policy/"
                target="_blank">プライバシーポリシー</a><br />
              {{ $globalVar.autoRTInfo.clientName }}の<a :href="$globalVar.autoRTInfo.termurl" target="_blank">利用規約</a>、<a
                :href="$globalVar.autoRTInfo.privacyurl" target="_blank">{{ $globalVar.autoRTInfo.privacyLabel || '個人情報保護方針' }}</a><a
                v-if="$globalVar.autoRTInfo.handlingurl" :href="$globalVar.autoRTInfo.handlingurl"
                target="_blank">、個人情報の取扱い</a><a v-if="$globalVar.autoRTInfo.occupationurl"
                :href="$globalVar.autoRTInfo.occupationurl" target="_blank">、取扱職種の範囲等の明示</a>を確認して{{ $globalVar.autoRTInfo.clientServiceName }}に登録することになります。<br v-if="$globalVar.autoRTInfo.showTrailingBr">
              ※ご経験やスキルに応じて求人をご案内する場合があります
            </p>
          </div>
          <p class="roxxrt_container__txt">
            <el-checkbox class="rt-agree-checkbox" v-model="isAgree" @change="onRtAgreeChange()">
            </el-checkbox>　規約に同意して無料相談を希望する
          </p>
        </div>

        <div id="completed-buttons" class="bnr_container" v-if="isWeekEndFlag">

          <div id="quickemail" class="bnr_itemWrapper">
            <div class="bnr_item">
              <div class="bnr_txt" style="border-radius: 10px 10px 0 0;">
                <el-button id="quick-email-btn" style="width:100%;border:0px;padding:0px;background: #EFF8F8;"
                  :disabled="!$deviceLib.isOnline || !localIsSendYagiEmailEnabled"
                  @click="handleYagiEmailClick('send-special-quickemail', formatId)">
                  <p>応募先企業に1クリックで送信</p>
                  <br>
                  <h3>ヤギのメール便<span>をつかう</span></h3>
                </el-button>
              </div>
              <img src="/static/renew2_img/quickemail_img20231122.png" alt="ヤギのメール便"
                style="border-radius: 0 0 10px 10px;">
            </div>
          </div>

          <div id="pdf-email" class="bnr_itemWrapper" v-if="$firebase.user && $firebase.user.emailVerified">
            <div class="bnr_item">
              <div class="bnr_txt" style="border-radius: 10px 10px 0 0;">
                <el-button id="pdf-mail-btn" style="width:100%;border:0px;padding:0px;background: #EFF8F8;"
                  :disabled="!$deviceLib.isOnline || !mailPdfEnabled" @click="handleEventWithLoginCheck('mail-PDF')">
                  <p>登録したメアドに送るメェ〜</p>
                  <br>
                  <h3>PDFをメールで送る</h3>
                </el-button>
              </div>
              <img src="/static/renew2_img/pdf_mail_20230929.png" alt="PDFメール" style="border-radius: 0 0 10px 10px;">
            </div>
          </div>
          <div id="pdf-email-none" class="bnr_itemWrapper" v-else>
            <div class="bnr_item">
              <div class="bnr_txt txt">
                <el-button id="pdf-mail-btn" style="width:100%;border:0px;padding:0px;background: #EFF8F8;"
                  :disabled="!$deviceLib.isOnline"
                  @click="$firebase.isAuthenticated ? $eventHub.$emit('send-email-verification') : handleEventWithLoginCheck('send-email-verification')">
                  <template v-if="$firebase.isAuthenticated">
                    <p>PDFファイルを</p>
                    <p>登録したメアドに送るためには</p>
                    <br>
                    <h3>確認メールで送る</h3>
                  </template>
                  <template v-else>
                    <p>ログインして</p>
                    <p>PDFファイルを</p>
                    <br>
                    <h3>メールで送る</h3>
                  </template>
                </el-button>
              </div>
              <p class="bnr_note">
                <a href="https://www.yagish.jp/information/pdf_mail_setting/" target="_blank"
                  rel="nofollow">※できない場合はこちら</a>
              </p>
              <p class="bnr_note" v-if="!$firebase.isAuthenticated">※ログインが必要です。</p>
            </div>
          </div>

          <div id="combie" class="bnr_itemWrapper">
            <div class="bnr_item">
              <div class="bnr_txt" style="border-radius: 10px 10px 0 0;">
                <el-button id="pdf-eprint-btn" style="width:100%;border:0px;padding:0px;background: #EFF8F8;"
                  @click="handleEventWithLoginCheck('show-preview-4conv')">
                  <p>作った履歴書、今すぐ印刷するメェ〜！</p>
                  <br>
                  <h3>コンビニで今すぐ印刷<span>する</span></h3>
                </el-button>
              </div>
              <img src="/static/renew_img/print.png" alt="コンビニプリント" style="border-radius: 0 0 10px 10px;">
            </div>
          </div>

          <div id="quickmail" class="bnr_itemWrapper">
            <div class="bnr_item">
              <div class="bnr_txt" style="border-radius: 10px 10px 0 0;">
                <el-button id="quick-mail-btn" style="width:100%;border:0px;padding:0px;background: #EFF8F8;"
                  :disabled="!$deviceLib.isOnline || !isSendYagiPostEnabled"
                  @click="$eventHub.$emit('send-special-post', formatId); isSendYagiPostEnabled = false">
                  <p>履歴書送付は任せろメェ〜</p>
                  <br>
                  <h3>ヤギの宅配便<span>をつかう</span></h3>
                </el-button>
              </div>
              <img src="/static/renew_img/mailbuy.png" alt="ヤギの宅配便" style="border-radius: 0 0 10px 10px;">
            </div>
          </div>

          <div id="pdf-download" class="bnr_itemWrapper" v-if="false">
            <div class="bnr_item">
              <div class="bnr_txt txt">
                <el-button id="pdf-download-btn" style="width:100%;border:0px;padding:0px;background: #EFF8F8;"
                  :disabled="!$deviceLib.isOnline || !downloadPdfEnabled"
                  @click="handleEventWithLoginCheck('download-PDF')">
                  <p>端末に保存するメェ〜</p>
                  <br>
                  <h3>PDFをダウンロードする</h3>
                </el-button>
              </div>
              <p class="bnr_note">
                <a href="https://www.yagish.jp/information/2022-04-06-163828/?utm_source=blogWidget" target="_blank"
                  rel="nofollow">※できない場合はこちら</a>
              </p>
            </div>
          </div>

          <div id="pdf-download" class="bnr_itemWrapper" v-if="$site.appFlag != 'b'">
            <div class="bnr_item">
              <div class="bnr_txt" style="border-radius: 10px 10px 0 0;">
                <el-button id="pdf-download-btn" style="width:100%;border:0px;padding:0px;background: #EFF8F8;"
                  :disabled="!$deviceLib.isOnline || !downloadPdfEnabled"
                  @click="handleEventWithLoginCheck('download-PDF')">
                  <p>端末に保存するメェ〜</p>
                  <br>
                  <h3>PDFをダウンロードする</h3>
                </el-button>
              </div>
              <img src="/static/renew2_img/pdf_download_20230929.png" alt="PDFダウンロード"
                style="border-radius: 0 0 10px 10px;">
            </div>
          </div>

        </div>

        <div id="completed-buttons" class="bnr_container" v-if="formatId == 'shiboudoukisho'">

          <div id="combie" class="bnr_itemWrapper">
            <div class="bnr_item">
              <img src="/static/renew2_img/print_20231024.png" alt="コンビニプリント" id="pdf-eprint-btn"
                @click="handleEventWithLoginCheck('show-preview-4conv')">
              <div class="bnr_txt">
                <el-button id="pdf-eprint-btn" style="width:100%;border:0px;padding:0px;background: #EFF8F8;"
                  @click="handleEventWithLoginCheck('show-preview-4conv')">
                  <p>作った履歴書、今すぐ印刷するメェ〜！</p>
                  <br>
                  <h3>コンビニで今すぐ印刷<span></span></h3>
                </el-button>
              </div>
            </div>
          </div>

          <div id="pdf-email" class="bnr_itemWrapper" v-if="$firebase.user && $firebase.user.emailVerified">
            <div class="bnr_item free-icon">
              <img src="/static/renew2_img/mail_bnr_20231011.png" id="pdf-mail-btn"
                :disabled="!$deviceLib.isOnline || !mailPdfEnabled" @click="handleEventWithLoginCheck('mail-PDF')">
              <div class="bnr_txt">
                <el-button id="pdf-mail-btn" style="width:100%;border:0px;padding:0px;background: #EFF8F8;"
                  :disabled="!$deviceLib.isOnline" @click="handleEventWithLoginCheck('mail-PDF')">

                  <span>
                    <p>登録したメアドに送るメェ〜</p><br>
                    <h3>自分にメール</h3>
                  </span>
                </el-button>
              </div>
              <p class="bnr_note">
                <a href="https://www.yagish.jp/information/pdf_mail_setting/" target="_blank"
                  rel="nofollow">※メールが受信できない場合はこちら</a>
              </p>
              <p class="bnr_note" v-if="!$firebase.isAuthenticated">※ログインが必要です。</p>
            </div>
          </div>
          <div id="pdf-email-none" class="bnr_itemWrapper" v-else>
            <div class="bnr_item"
              :class="{ 'free-icon': !$firebase.isAuthenticated || ($firebase.user && $firebase.user.emailVerified) }">
              <img src="/static/renew2_img/mail_bnr_20231011.png" id="pdf-mail-btn"
                v-if="!$firebase.isAuthenticated || ($firebase.user && $firebase.user.emailVerified)"
                :disabled="!$deviceLib.isOnline || !mailPdfEnabled"
                @click="$firebase.isAuthenticated ? $eventHub.$emit('send-email-verification') : handleEventWithLoginCheck('send-email-verification')">
              <div class="bnr_txt">
                <el-button id="pdf-mail-btn" style="width:100%;border:0px;padding:0px;background: #EFF8F8;"
                  :disabled="!$deviceLib.isOnline"
                  @click="$firebase.isAuthenticated ? $eventHub.$emit('send-email-verification') : handleEventWithLoginCheck('send-email-verification')">
                  <template v-if="$firebase.isAuthenticated">
                    <span>
                      <p>PDFファイルを</p>
                      <p>登録したメアドに送るためには</p>
                      <br>
                      <h3>確認メールで送る</h3>
                    </span>
                  </template>
                  <template v-else>
                    <span>
                      <p>ログインしてPDFファイルを</p>
                      <br>
                      <h3>メールで送る</h3>
                    </span>
                  </template>
                </el-button>
              </div>
              <p class="bnr_note">
                <a href="https://www.yagish.jp/information/pdf_mail_setting/" target="_blank"
                  rel="nofollow">※メールが受信できない場合はこちら</a>
              </p>
              <p class="bnr_note" v-if="!$firebase.isAuthenticated">※ログインが必要です。</p>
            </div>
          </div>

          <div id="pdf-download" class="bnr_itemWrapper" v-if="$site.appFlag != 'b'">
            <div class="bnr_item free-icon">
              <img src="/static/renew2_img/download_bnr_20231011.png" id="pdf-download-btn"
                :disabled="!$deviceLib.isOnline" @click="handleEventWithLoginCheck('download-PDF')">
              <div class="bnr_txt">
                <el-button id="pdf-download-btn" style="width:100%;border:0px;padding:0px;background: #EFF8F8;"
                  :disabled="!$deviceLib.isOnline" @click="handleEventWithLoginCheck('download-PDF')">
                  <span class="">
                    <p>端末に保存するメェ〜</p><br>
                    <h3>端末に保存</h3>
                  </span>
                </el-button>
              </div>
              <p class="bnr_note">
                <a href="https://www.yagish.jp/information/2022-04-06-163828/?utm_source=blogWidget" target="_blank"
                  rel="nofollow">※できない場合はこちら</a>
              </p>
            </div>
          </div>

          <div id="quickemail" class="bnr_itemWrapper" v-if="$globalVar.in_app_payments">
            <div class="bnr_item">
              <img :src="currentImageUrl" alt="ヤギのメール便"
                :disabled="!$deviceLib.isOnline || !localIsSendYagiEmailEnabled" id="quick-email-btn"
                @click="handleYagiEmailClick('send-special-quickemail', formatId)">
              <div class="bnr_txt">
                <el-button id="quick-email-btn" style="width:100%;border:0px;padding:0px;background: #EFF8F8;"
                  :disabled="!$deviceLib.isOnline || !localIsSendYagiEmailEnabled"
                  @click="handleYagiEmailClick('send-special-quickemail', formatId)">
                  <p>{{ currentTextLabel }}</p>
                  <br>
                  <h3>企業に履歴書を送る/応募する</h3>
                </el-button>
              </div>
            </div>
          </div>

        </div>

        <div id="completed-buttons" class="bnr_container" v-else>

          <div id="pdf-email" class="bnr_itemWrapper" v-if="$firebase.user && $firebase.user.emailVerified">
            <div class="bnr_item free-icon">
              <img src="/static/renew2_img/mail_bnr_20231011.png" id="pdf-mail-btn"
                :disabled="!$deviceLib.isOnline || !mailPdfEnabled" @click="handleEventWithLoginCheck('mail-PDF')">
              <div class="bnr_txt">
                <el-button id="pdf-mail-btn" style="width:100%;border:0px;padding:0px;background: #EFF8F8;"
                  :disabled="!$deviceLib.isOnline" @click="handleEventWithLoginCheck('mail-PDF')">

                  <span>
                    <p>登録したメアドに送るメェ〜</p><br>
                    <h3>自分にメール</h3>
                  </span>
                </el-button>
              </div>
              <p class="bnr_note">
                <a href="https://www.yagish.jp/information/pdf_mail_setting/" target="_blank"
                  rel="nofollow">※メールが受信できない場合はこちら</a>
              </p>
              <p class="bnr_note" v-if="!$firebase.isAuthenticated">※ログインが必要です。</p>
            </div>
          </div>
          <div id="pdf-email-none" class="bnr_itemWrapper" v-else>
            <div class="bnr_item"
              :class="{ 'free-icon': !$firebase.isAuthenticated || ($firebase.user && $firebase.user.emailVerified) }">
              <img src="/static/renew2_img/mail_bnr_20231011.png" id="pdf-mail-btn"
                v-if="!$firebase.isAuthenticated || ($firebase.user && $firebase.user.emailVerified)"
                :disabled="!$deviceLib.isOnline || !mailPdfEnabled"
                @click="$firebase.isAuthenticated ? $eventHub.$emit('send-email-verification') : handleEventWithLoginCheck('send-email-verification')">
              <div class="bnr_txt">
                <el-button id="pdf-mail-btn" style="width:100%;border:0px;padding:0px;background: #EFF8F8;"
                  :disabled="!$deviceLib.isOnline"
                  @click="$firebase.isAuthenticated ? $eventHub.$emit('send-email-verification') : handleEventWithLoginCheck('send-email-verification')">
                  <template v-if="$firebase.isAuthenticated">
                    <span>
                      <p>PDFファイルを</p>
                      <p>登録したメアドに送るためには</p>
                      <br>
                      <h3>確認メールで送る</h3>
                    </span>
                  </template>
                  <template v-else>
                    <span>
                      <p>ログインしてPDFファイルを</p>
                      <br>
                      <h3>メールで送る</h3>
                    </span>
                  </template>
                </el-button>
              </div>
              <p class="bnr_note">
                <a href="https://www.yagish.jp/information/pdf_mail_setting/" target="_blank"
                  rel="nofollow">※メールが受信できない場合はこちら</a>
              </p>
              <p class="bnr_note" v-if="!$firebase.isAuthenticated">※ログインが必要です。</p>
            </div>
          </div>

          <div id="combie" class="bnr_itemWrapper">
            <div class="bnr_item">
              <img src="/static/renew2_img/print_20231024.png" alt="コンビニプリント" id="pdf-eprint-btn"
                @click="handleEventWithLoginCheck('show-preview-4conv')">
              <div class="bnr_txt">
                <el-button id="pdf-eprint-btn" style="width:100%;border:0px;padding:0px;background: #EFF8F8;"
                  @click="handleEventWithLoginCheck('show-preview-4conv')">
                  <p>作った履歴書、今すぐ印刷するメェ〜！</p>
                  <br>
                  <h3>コンビニで今すぐ印刷<span></span></h3>
                </el-button>
              </div>
            </div>
          </div>

          <div id="quickemail" class="bnr_itemWrapper"
            v-if="$globalVar.in_app_payments && formatId != 'rirekisho_design_001' && formatId != 'rirekisho_design_002' && formatId != 'shokumukeirekisho_with_image' && formatId != 'taishokutodoke'">
            <div class="bnr_item">
              <p>{{ getDate }}</p>

              <!--A.(2025.11.26~)-->
              <img :src="currentImageUrl" alt="ヤギのメール便" :disabled="!$deviceLib.isOnline || !localIsSendYagiEmailEnabled"
                id="quick-email-btn" @click="handleYagiEmailClick('send-special-quickemail', formatId)">

              <!--B.(2025.12.03~)-->

              <!--C.(2025.12.10~)-->

              <!--D.(2025.12.17~)-->

              <!--基本-->
              <!--<img src="/static/renew2_img/quickemail_new_btn_20250520.jpg" alt="ヤギのメール便"
                :disabled="!$deviceLib.isOnline || !localIsSendYagiEmailEnabled" id="quick-email-btn"
                @click="handleYagiEmailClick('send-special-quickemail', formatId)">-->

              <div class="bnr_txt">
                <el-button id="quick-email-btn" style="width:100%;border:0px;padding:0px;background: #EFF8F8;"
                  :disabled="!$deviceLib.isOnline || !localIsSendYagiEmailEnabled"
                  @click="handleYagiEmailClick('send-special-quickemail', formatId)">
                  <!--<p>{{ qemailBtnLabel }}</p>-->
                  <p>{{ currentTextLabel }}</p>
                  <br>
                  <h3>応募先にメール</h3>
                </el-button>
              </div>
            </div>
          </div>
          <div id="quickemail" class="bnr_itemWrapper" v-else-if="false">
            <div class="bnr_item">
              <img src="/static/renew2_img/quickemail_btn_20240221.png" alt="ヤギのメール便"
                :disabled="!$deviceLib.isOnline || !localIsSendYagiEmailEnabled" id="quick-email-btn"
                @click="handleYagiEmailClick('send-special-newquickemail', formatId)">
              <div class="bnr_txt">
                <el-button id="quick-email-btn" style="width:100%;border:0px;padding:0px;background: #EFF8F8;"
                  :disabled="!$deviceLib.isOnline || !localIsSendYagiEmailEnabled"
                  @click="handleYagiEmailClick('send-special-newquickemail', formatId)">
                  <p>{{ qemailBtnLabel }}</p>
                  <br>
                  <h3>応募先にメール<span></span></h3>
                </el-button>
              </div>
            </div>
          </div>

          <div id="pdf-download" class="bnr_itemWrapper" v-if="$site.appFlag != 'b'">
            <div class="bnr_item free-icon">
              <img src="/static/renew2_img/download_bnr_20231011.png" id="pdf-download-btn"
                :disabled="!$deviceLib.isOnline" @click="handleEventWithLoginCheck('download-PDF')">
              <div class="bnr_txt">
                <el-button id="pdf-download-btn" style="width:100%;border:0px;padding:0px;background: #EFF8F8;"
                  :disabled="!$deviceLib.isOnline" @click="handleEventWithLoginCheck('download-PDF')">
                  <span class="">
                    <p>端末に保存するメェ〜</p><br>
                    <h3>端末に保存</h3>
                  </span>
                </el-button>
              </div>
              <p class="bnr_note">
                <a href="https://www.yagish.jp/information/2022-04-06-163828/?utm_source=blogWidget" target="_blank"
                  rel="nofollow">※できない場合はこちら</a>
              </p>
            </div>
          </div>

        </div>

      </div>
      <!--<div class="button-download-wrapper" v-else>
        <login-forms />
      </div>-->
    </div>

    <div id="dl_useraim" v-if="false && formatId != 'rirekisho_esf_challenged' && abtest == 0">
      <div class="card-content" v-if="$firebase.isAuthenticated">
        <div class="button-download-pdf"><!---->
          <div id="completed-buttons" class="pdf-download-box-wrap"><!--ここまでが共通-->

            <div class="pdf-download-box">
              <div class="left">
                <h3 class="h3">PDFを使う</h3>
                <div class="btn-list">
                  <img src="/static/renew2_img/download_page_mail_20240425.png" alt="PDFを使う" class="btn-img">
                  <div class="btn-item" v-if="$firebase.user && $firebase.user.emailVerified">
                    <el-button id="pdf-mail-btn" :disabled="!$deviceLib.isOnline || !mailPdfEnabled"
                      @click="handleEventWithLoginCheck('mail-PDF')">
                      メールに送る
                    </el-button>
                    <a href="https://www.yagish.jp/information/pdf_mail_setting/" target="_blank" class="notelink"><span
                        class="notelink-icon">?</span>メールが受信できない場合</a>
                  </div>
                  <div class="btn-item" v-else>
                    <el-button id="pdf-mail-btn" :disabled="!$deviceLib.isOnline || !mailPdfEnabled"
                      @click="$firebase.isAuthenticated ? $eventHub.$emit('send-email-verification') : handleEventWithLoginCheck('send-email-verification')">
                      <template v-if="$firebase.isAuthenticated">
                        認証メールで送る
                      </template>
                      <template v-else>
                        ログインしてメールで送る
                      </template>
                    </el-button>
                    <a href="https://www.yagish.jp/information/pdf_mail_setting/" target="_blank" class="notelink"><span
                        class="notelink-icon">?</span>メールが受信できない場合</a>
                  </div>
                  <div class="btn-item"
                    v-if="formatId != 'rirekisho_design_001' && formatId != 'rirekisho_design_002' && formatId != 'entrysheet' && $globalVar.in_app_payments">
                    <el-button id="quick-email-btn" :disabled="!$deviceLib.isOnline || !localIsSendYagiEmailEnabled"
                      @click="handleYagiEmailClick('send-special-quickemail', formatId)">
                      企業にメール
                    </el-button>
                    <a href="/quickemailhelp" target="_blank" class="notelink"><span
                        class="notelink-icon">?</span>ヤギのメール便について</a>
                  </div>
                </div>
              </div>
              <div class="right"
                v-if="formatId != 'rirekisho_design_001' && formatId != 'rirekisho_design_002' && formatId != 'entrysheet'">
                <h3 class="h3">紙に印刷</h3>
                <div class="btn-list">
                  <img src="/static/renew2_img/download_page_paper_20240425.png" alt="紙に印刷" class="btn-img">
                  <div class="btn-item">
                    <el-button id="pdf-eprint-btn" @click="handleEventWithLoginCheck('show-preview-4conv')">
                      今すぐコンビニで印刷
                    </el-button>
                    <a tabindex="-1" class="notelink">※コンテンツ番号を発行</a>
                  </div>
                  <div class="btn-item" v-if="$globalVar.in_app_payments">
                    <el-button id="quick-mail-btn" :disabled="!$deviceLib.isOnline || !isSendYagiPostEnabled"
                      @click="$eventHub.$emit('send-special-post', formatId); isSendYagiPostEnabled = false">
                      企業に郵送代行
                    </el-button>
                    <a href="/quickmailhelp" target="_blank" class="notelink"><span
                        class="notelink-icon">?</span>ヤギの宅配便について</a>
                  </div>
                </div>
              </div>
              <div class="bottom" v-if="$site.appFlag != 'b'">
                <div class="btn-item">
                  <el-button id="pdf-download-btn" :disabled="!$deviceLib.isOnline || !downloadPdfEnabled"
                    @click="handleEventWithLoginCheck('download-PDF')">
                    端末に保存
                  </el-button>
                  <a href="https://www.yagish.jp/information/2022-04-06-163828/?utm_source=blogWidget" target="_blank"
                    class="notelink"><span class="notelink-icon">?</span>端末に保存できない場合</a>
                </div>
              </div>
            </div>

          </div>
        </div>
      </div>
      <div class="card-content" v-else>
        <div class="text-center">
          <login-forms />
        </div>
      </div>
    </div>

    <div id="dl_useraim" v-else-if="false && formatId != 'rirekisho_esf_challenged' && abtest == 1">
      <div class="card-content" v-if="$firebase.isAuthenticated">
        <div class="button-download-pdf"><!---->
          <div id="completed-buttons" class="pdf-download-box-wrap"><!--ここまでが共通-->

            <div class="pdf-download-box">
              <div class="left">
                <h3 class="h3">PDFを利用</h3>
                <div class="btn-list">
                  <img src="/static/renew2_img/download_page_mail_20240509p1.png" alt="PDFを使う" class="btn-img">
                  <div class="btn-item" v-if="$firebase.user && $firebase.user.emailVerified">
                    <el-button id="pdf-mail-btn" :disabled="!$deviceLib.isOnline || !mailPdfEnabled"
                      @click="handleEventWithLoginCheck('mail-PDF')">
                      自分にメール
                    </el-button>
                    <a href="https://www.yagish.jp/information/pdf_mail_setting/" target="_blank" class="notelink"><span
                        class="notelink-icon">?</span>メールが受信できない場合</a>
                  </div>
                  <div class="btn-item" v-else>
                    <el-button id="pdf-mail-btn" :disabled="!$deviceLib.isOnline || !mailPdfEnabled"
                      @click="$firebase.isAuthenticated ? $eventHub.$emit('send-email-verification') : handleEventWithLoginCheck('send-email-verification')">
                      <template v-if="$firebase.isAuthenticated">
                        認証メールで送る
                      </template>
                      <template v-else>
                        ログインしてメールで送る
                      </template>
                    </el-button>
                    <a href="https://www.yagish.jp/information/pdf_mail_setting/" target="_blank" class="notelink"><span
                        class="notelink-icon">?</span>メールが受信できない場合</a>
                  </div>
                  <div class="btn-item"
                    v-if="$globalVar.in_app_payments && formatId != 'rirekisho_design_001' && formatId != 'rirekisho_design_002' && formatId != 'entrysheet'">
                    <el-button id="quick-email-btn" :disabled="!$deviceLib.isOnline || !localIsSendYagiEmailEnabled"
                      @click="handleYagiEmailClick('send-special-quickemail', formatId)">
                      応募先にメール
                    </el-button>
                    <a href="/quickemailhelp" target="_blank" class="notelink"><span
                        class="notelink-icon">?</span>ヤギのメール便について</a>
                  </div>
                </div>
              </div>
              <div class="right"
                v-if="formatId != 'rirekisho_design_001' && formatId != 'rirekisho_design_002' && formatId != 'entrysheet'">
                <h3 class="h3">印刷して利用</h3>
                <div class="btn-list">
                  <img src="/static/renew2_img/download_page_paper_20240509p1.png" alt="紙に印刷" class="btn-img">
                  <div class="btn-item">
                    <el-button id="pdf-eprint-btn" @click="handleEventWithLoginCheck('show-preview-4conv')">
                      今すぐコンビニで印刷
                    </el-button>
                    <a tabindex="-1" class="notelink">※コンテンツ番号を発行</a>
                  </div>
                  <div class="btn-item" v-if="$globalVar.in_app_payments">
                    <el-button id="quick-mail-btn" :disabled="!$deviceLib.isOnline || !isSendYagiPostEnabled"
                      @click="$eventHub.$emit('send-special-post', formatId); isSendYagiPostEnabled = false">
                      {{ qmailBtnLabel }}
                    </el-button>
                    <a href="/quickmailhelp" target="_blank" class="notelink"><span
                        class="notelink-icon">?</span>ヤギの宅配便について</a>
                  </div>
                </div>
              </div>
              <div class="bottom" v-if="$site.appFlag != 'b'">
                <div class="btn-item">
                  <el-button id="pdf-download-btn" :disabled="!$deviceLib.isOnline || !downloadPdfEnabled"
                    @click="handleEventWithLoginCheck('download-PDF')">
                    端末に保存
                  </el-button>
                  <a href="https://www.yagish.jp/information/2022-04-06-163828/?utm_source=blogWidget" target="_blank"
                    class="notelink"><span class="notelink-icon">?</span>端末に保存できない場合</a>
                </div>
              </div>
            </div>

          </div>
        </div>
      </div>
      <div class="card-content" v-else>
        <div class="text-center">
          <login-forms />
        </div>
      </div>
    </div>

    <div id="dl_useraim" v-else-if="false && formatId != 'rirekisho_esf_challenged' && abtest == 2">
      <div class="card-content" v-if="$firebase.isAuthenticated">
        <div class="button-download-pdf"><!---->
          <div id="completed-buttons" class="pdf-download-box-wrap"><!--ここまでが共通-->

            <div class="pdf-download-box">
              <div class="left">
                <h3 class="h3">PDFを利用</h3>
                <div class="btn-list">
                  <img src="/static/renew2_img/download_page_mail_20240509p2.png" alt="PDFを使う" class="btn-img">
                  <div class="btn-item" v-if="$firebase.user && $firebase.user.emailVerified">
                    <el-button id="pdf-mail-btn" :disabled="!$deviceLib.isOnline || !mailPdfEnabled"
                      @click="handleEventWithLoginCheck('mail-PDF')">
                      自分にメール
                    </el-button>
                    <a href="https://www.yagish.jp/information/pdf_mail_setting/" target="_blank" class="notelink"><span
                        class="notelink-icon">?</span>メールが受信できない場合</a>
                  </div>
                  <div class="btn-item" v-else>
                    <el-button id="pdf-mail-btn" :disabled="!$deviceLib.isOnline || !mailPdfEnabled"
                      @click="$firebase.isAuthenticated ? $eventHub.$emit('send-email-verification') : handleEventWithLoginCheck('send-email-verification')">
                      <template v-if="$firebase.isAuthenticated">
                        認証メールで送る
                      </template>
                      <template v-else>
                        ログインしてメールで送る
                      </template>
                    </el-button>
                    <a href="https://www.yagish.jp/information/pdf_mail_setting/" target="_blank" class="notelink"><span
                        class="notelink-icon">?</span>メールが受信できない場合</a>
                  </div>
                  <div class="btn-item"
                    v-if="$globalVar.in_app_payments && formatId != 'rirekisho_design_001' && formatId != 'rirekisho_design_002' && formatId != 'entrysheet'">
                    <el-button id="quick-email-btn" :disabled="!$deviceLib.isOnline || !localIsSendYagiEmailEnabled"
                      @click="handleYagiEmailClick('send-special-quickemail', formatId)">
                      応募先にメール
                    </el-button>
                    <a href="/quickemailhelp" target="_blank" class="notelink"><span
                        class="notelink-icon">?</span>ヤギのメール便について</a>
                  </div>
                </div>
              </div>
              <div class="right"
                v-if="formatId != 'rirekisho_design_001' && formatId != 'rirekisho_design_002' && formatId != 'entrysheet'">
                <h3 class="h3">印刷して利用</h3>
                <div class="btn-list">
                  <img src="/static/renew2_img/download_page_paper_20240509p2.png" alt="紙に印刷" class="btn-img">
                  <div class="btn-item">
                    <el-button id="pdf-eprint-btn" @click="handleEventWithLoginCheck('show-preview-4conv')">
                      今すぐコンビニで印刷
                    </el-button>
                    <a tabindex="-1" class="notelink">※コンテンツ番号を発行</a>
                  </div>
                  <div class="btn-item" v-if="$globalVar.in_app_payments">
                    <el-button id="quick-mail-btn" :disabled="!$deviceLib.isOnline || !isSendYagiPostEnabled"
                      @click="$eventHub.$emit('send-special-post', formatId); isSendYagiPostEnabled = false">
                      郵送を依頼
                    </el-button>
                    <a href="/quickmailhelp" target="_blank" class="notelink"><span
                        class="notelink-icon">?</span>ヤギの宅配便について</a>
                  </div>
                </div>
              </div>
              <div class="bottom" v-if="$site.appFlag != 'b'">
                <div class="btn-item">
                  <el-button id="pdf-download-btn" :disabled="!$deviceLib.isOnline || !downloadPdfEnabled"
                    @click="handleEventWithLoginCheck('download-PDF')">
                    端末に保存
                  </el-button>
                  <a href="https://www.yagish.jp/information/2022-04-06-163828/?utm_source=blogWidget" target="_blank"
                    class="notelink"><span class="notelink-icon">?</span>端末に保存できない場合</a>
                </div>
              </div>
            </div>

          </div>
        </div>
      </div>
      <div class="card-content" v-else>
        <div class="text-center">
          <login-forms />
        </div>
      </div>
    </div>

    <login-form />

  </div>
</template>
<style lang="scss" scoped>
.yagitaku {
  line-height: 25px;
  padding: 15px 0;
  font-weight: bold;
}

.yagitaku_recommend {
  color: #fff;
  background: #E3165C;
  padding: 5px 10px;
  margin-right: 5px;
  border-radius: 50px;
}

.yagitaku_link {
  color: #E3165C;
  border-bottom: 1px solid #E3165C;
}

.create-date_bnr {
  margin: 15px 0;
}

.el-button--success.overwrite.overwrite,
.el-button--primary.overwrite {
  color: #000;
  background: #EFF8F8;
  border: none;
  display: block;
  padding: 0;
  border-radius: 15px;
  white-space: normal;
  line-height: 1.8;
}

.el-button--success.overwrite.overwrite:hover,
.el-button--primary.overwrite:hover {
  background: none;
  color: #000;
}

.addition {
  font-size: .75rem;
  margin: .5rem 0;
}

* {
  list-style: none;
  box-sizing: border-box;
  margin: 0;
  padding: 0;
}

img {
  width: 100%;
  vertical-align: bottom;
}

.next_bnr {
  font-size: 1rem;
  color: #004d40;
  text-align: center;
  padding: 1.2rem;
}

.bnr_container {
  display: flex;
  flex-wrap: wrap;
  margin: calc(-30px / 2);
  //padding: 30px;
}

.bnr_itemWrapper {
  width: calc(100% / 2 - 30px);
  margin: calc(30px / 2);
}

.bnr_item {
  text-align: center;
}

.bnr_item img {
  border-radius: 10px 10px 0 0;
}

.bnr_txt {
  padding: 15px;
  background: #EFF8F8;
  border-radius: 0 0 10px 10px;
}

.txt {
  border-radius: 10px;
}

.bnr_txt p {
  font-size: 0.8rem;
  font-weight: bold;

}

.bnr_txt h3 {
  color: #E3165C;
  font-size: 1.1rem;
  font-weight: bold;
}

.bnr_txt span {
  font-size: 0.8rem;
}

.create-date_txt {
  border-radius: 10px;
}

.bnr_note {
  font-size: 0.8rem;
}

.card-header h1 {
  padding-bottom: 1.5rem;
}

.card-header h2 {
  padding-bottom: 1.5rem;
}

/* タブレット　2カラム */
@media screen and (max-width: 1024px) {
  .bnr_itemWrapper {
    width: calc(100% / 2 - 30px);
  }
}

/* スマホ 1カラム*/
@media screen and (max-width: 599px) {
  .bnr_itemWrapper {
    width: calc(100% / 1 - 30px);
  }
}

.free-icon {
  position: relative;
}

.free-icon::before {
  position: absolute;
  content: "";
  // background-image: url(/static/renew2_img/free_icon.png);
  width: 62px;
  height: 39px;
  background-size: contain;
  display: inline-block;
  top: 5px;
  left: 5px;
}
</style>
<style lang="scss" scoped>
#dl_2column .h3 {
  text-align: center;
  margin-bottom: 10px;
}

#dl_2column .pdf-download-box,
#dl_2column .pdf-eprint-box {
  margin-bottom: 30px;
}

#dl_2column .pdf-eprint-box .bnr_container {
  justify-content: center;
}

@media screen and (max-width: 599px) {

  #dl_2column .card-content {
    padding-left: 0;
    padding-right: 0;
    border-top: 1px solid #f8f8f8;
  }

  #dl_2column .bnr_itemWrapper {
    width: calc(100% / 2 - 5px);
    margin: 0;
  }

  #dl_2column .bnr_container {
    justify-content: space-between;
    margin: 0;
  }

  #dl_2column .bnr_note {
    font-size: 0.6rem;
    margin-top: 8px;
  }

  #dl_2column .bnr_item img {
    border-radius: 5px 5px 0 0;
  }

  #dl_2column .bnr_txt {
    border-radius: 0 0 5px 5px;
  }
}
</style>
<style lang="scss" scoped>
#dl_disability .card-content {
  padding-top: 0;
}

#dl_disability .bnr_itemWrapper {
  width: 100%;
  margin: 0;
  background: #FFF0F0;
  border-radius: 10px;
  border: 3px solid #E3165C;
  justify-content: center;
  align-items: center;
}

#dl_disability .bnr_txt {
  border-radius: 0;
  background: none;
  padding: 0 15px 10px;
}

#dl_disability .bnr_txt p {
  font-size: 14px;
  font-weight: normal;
  font-family: auto;
}

#dl_disability .bnr_txt p a {
  font-size: 12px;
}

#dl_disability .intro_icon {
  padding: 20px;
  width: 150px;
}

#dl_disability .request-btn {
  color: #fff;
  font-size: 1.2rem;
  font-weight: bold;
  padding: 10px 50px;
  margin-top: 10px;
  background: #E3165C;
  border-radius: 50px;
}

#dl_disability .note {
  font-size: 12px;
}

#dl_disability .edit-wrapper {
  margin-top: 30px;
  background: #eee;
  border-radius: 10px;
  padding: 20px;
}

#dl_disability .edit-wrapper .bnr_txt {
  justify-content: center;
  align-items: center;
  padding-bottom: 0;
}

#dl_disability .edit-wrapper .bnr_txt .edit-btn {
  padding: 5px 20px;
  background: #404040;
  color: #fff;
  border-radius: 50px;
  margin-left: 30px;
}

#dl_disability .other-action-block {
  margin-top: 50px;
}

#dl_disability .action-title {
  font-weight: bold;
  font-size: 15px;
  color: #004D40;
  margin-bottom: 10px;
  text-align: center;
}

#dl_disability .action-list {
  width: calc(100% / 3 - 10px);
  background: #eff8f8;
  border-radius: 10px;
  padding: 20px 10px 10px;
}

#dl_disability .other-action-block .flex {
  justify-content: space-between;
}

#dl_disability .el-button {
  border: none;
  padding: 0;
  background: no-repeat;
  color: #404040;
  font-weight: bold;
}

@media screen and (max-width: 640px) {
  #dl_disability .flex {
    display: block;
  }

  #dl_disability .action-list {
    width: 100%;
    margin-bottom: 15px;
  }

  #dl_disability .bnr_txt {
    text-align: center;
    padding-bottom: 20px;
  }

  #dl_disability .edit-wrapper .bnr_txt .edit-btn {
    margin-left: 0;
    margin-top: 10px;
  }
}
</style>
<style lang="scss" scoped>
@import '@/assets/scss/variables.scss';

#dl_useraim .pdf-download-box-wrap {
  background: #EEF5E8;
  margin: 0 calc(50% - 50vw);
  width: 100vw;
}

#dl_useraim .card-content {
  padding: 0;
}

#dl_useraim .pdf-download-box {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  padding: 1.5rem;
  max-width: 630px;
  margin: 0 auto;
}

#dl_useraim .left,
#dl_useraim .right {
  width: 49%;
  background: #fff;
  border-radius: 10px;
}

#dl_useraim .h3 {
  text-align: center;
  color: #fff;
  letter-spacing: 0.1rem;
  background: #004D40;
  padding: 10px;
  border-radius: 10px 10px 0 0;
  font-size: 1rem;
}

#dl_useraim .btn-img {
  display: block;
  height: 80px;
  width: auto;
  margin: 0 auto;
}

#dl_useraim .btn-list {
  padding: 10px;
}

#dl_useraim .btn-item {
  margin: 10px auto 15px;
}

#dl_useraim .btn-item:last-child {
  margin-bottom: 0;
}

#dl_useraim .btn-item button {
  position: relative;
  width: 100%;
  border: none;
  background: #E3165C;
  color: #fff;
  font-weight: bold;
  box-shadow: 0 4px 0 #8C103A;
}

#dl_useraim .btn-item button::after {
  position: absolute;
  content: "";
  right: 10px;
  top: 50%;
  margin-top: -4px;
  width: 8px;
  height: 8px;
  border-top: 2px solid #fff;
  border-right: 2px solid #fff;
  -webkit-transform: rotate(45deg);
  transform: rotate(45deg);
}

#dl_useraim .notelink {
  display: block;
  font-size: 0.6rem;
  margin-top: 5px;
}

#dl_useraim .notelink-icon {
  display: inline-block;
  width: 15px;
  height: 15px;
  border-radius: 50%;
  background: #404040;
  color: #fff;
  text-align: center;
  line-height: 15px;
  margin-right: 5px;
}

#dl_useraim .bottom {
  padding: 10px 10px 0;
  width: 49%;
}

#dl_useraim .bottom button {
  background: #fff;
  color: #404040;
  box-shadow: 0 4px 0 #004D40;
}

#dl_useraim .bottom .btn-item button::after {
  border-top: 2px solid #004D40;
  border-right: 2px solid #004D40;
}

#dl_useraim .btn-item button:hover {
  opacity: 1;
  transform: translateY(4px);
  box-shadow: none;
}

.roxxrt_container {
  text-align: center;
  font-size: 12px;

  @include max-width(sm) {
    font-size: 11px;
  }

  &__txt {
    display: flex;
    align-items: center;
    justify-content: center;
    margin: 0;
    line-height: 1.4;

    img {
      width: auto;
      height: 14px;
      object-fit: cover;
      margin-right: 4px;
    }

    // チェックボックス自体のスケール（インライン scale(1.4) で大きすぎていたものを縮小）
    .rt-agree-checkbox {
      transform: scale(0.9);
      transform-origin: right center;
      margin-right: 2px;

      @include max-width(sm) {
        transform: scale(0.85);
      }

      // チェック状態の色をプロジェクトテーマのピンクからグレーに上書き（scoped 配下のため ::v-deep）
      ::v-deep .el-checkbox__input.is-checked .el-checkbox__inner,
      ::v-deep .el-checkbox__input.is-indeterminate .el-checkbox__inner {
        background-color: #909399;
        border-color: #909399;
      }

      // フォーカス時の枠線色もグレーに合わせる
      ::v-deep .el-checkbox__input.is-focus .el-checkbox__inner {
        border-color: #909399;
      }

      // ラベル文字色がチェック時にピンクへ変わる挙動も無効化
      ::v-deep .el-checkbox__input.is-checked + .el-checkbox__label {
        color: inherit;
      }
    }
  }

  &__flex {
    display: flex;
    justify-content: center;
    align-items: center;
    flex-wrap: wrap;
    gap: 12px;
    padding: 4px 0 0;
    width: 90%;
    margin: 0 auto;

    @include max-width(sm) {
      padding: 4px 8px 0;
      width: 100%;
      gap: 8px;
    }

    .roxxrt_img {
      width: calc(50% - 6px);
      max-width: 220px;

      @include max-width(sm) {
        width: 100%;
        max-width: 180px;
      }
    }

    .roxxrt_txt {
      width: calc(50% - 6px);
      text-align: left;
      font-size: 11px;
      line-height: 1.5;

      @include max-width(sm) {
        width: 100%;
        font-size: 10px;
      }
    }

  }
}
</style>
<script>
import LoginForms from '@/components/LoginSpecialForms'
import ShogaiLoginForms from '@/components/ShogaiLoginSpecialForms'
import LoginDialog from '@/components/LoginDialog'
import { useDownloadItemAutoRt } from '@/composables/useDownloadItemAutoRt'

export default {
  props: {
    formatId: {
      type: String
    },
    isSendYagiPostEnabled: {
      type: Boolean
    },
    isSendYagiEmailEnabled: {
      type: Boolean
    },
    mailPdfEnabled: {
      type: Boolean
    },
    downloadPdfEnabled: {
      type: Boolean
    },
    downloadActiveCollapses: {
      type: Array
    }
  },
  components: {
    'login-forms': LoginForms,
    'shogailogin-forms': ShogaiLoginForms,
    'login-form': LoginDialog
  },
  data: function () {
    const app = this
    return {
      isWeekEndFlag: true,
      errors: [],
      abtest: 0,
      xmile_logo_img: '',
      pharmate_logo_img: '',
      recree_logo_img: '',
      isMaint: false,
      isSendedYagishIntern: false,
      localIsSendYagiEmailEnabled: true, // propの値をローカルで管理
      qemailBtnLabel: 'ポチッと企業に送信だメェ〜',
      qmailBtnLabel: '郵送を依頼',
      qemailBtnLabels20231113: [
        'ポチッと企業に送信だメェ〜',
        '提出までやっちゃうメェ〜',
        '1クリックで送信だメェ〜',
        'メールで提出は任せろメェ〜',
        'メールで送信まで任せてメェ〜'
      ],
      qemailBtnLabels: [
        'メールで企業に送信するなら⁉︎',
        'メールで効率的に企業に送信！',
        '履歴書を送って！と言われたら',
        '安全・安心に企業へ応募するなら',
        '1クリックで送信だメェ〜'
      ],
      pendingYagiEmailEvent: null, // ログイン待ちのヤギメールイベント情報を保存
      pendingEvent: null, // ログイン待ちの一般的なイベント情報を保存,
      isAgree: true,
      imageRules: [
        { image: '/static/renew2_img/quickemail_new_btn_A.png', start: '2025-11-26' },
        { image: '/static/renew2_img/quickemail_new_btn_B.png', start: '2025-12-03' },
        { image: '/static/renew2_img/quickemail_new_btn_C.png', start: '2025-12-10' },
        { image: '/static/renew2_img/quickemail_new_btn_D.png', start: '2025-12-17' },
        { image: '/static/renew2_img/quickemail_new_btn_20250311.jpg', start: '2026-03-11' },
        { image: '/static/renew2_img/quickemail_new_btn_20260407.jpg', start: '2026-04-07' },
        { image: '/static/renew2_img/quickemail_new_btn_20260419.png', start: '2026-04-19' }
      ],
      labelRules: [
        { label: '履歴書をPDFに変換してメールで送れる', start: '2025-11-26' },
        { label: 'ダウンロードの必要なし！履歴書を企業へ送信', start: '2025-12-03' },
        { label: 'パスワード付き！安全に履歴書(PDF)を送信！', start: '2025-12-10' },
        { label: 'ダウンロードも印刷も不要！企業へ直接送れる！', start: '2025-12-17' },
        { label: '企業名とメールアドレスを入れるだけ！', start: '2026-03-11' },
        { label: '予約送信で、時間や曜日を気にせず使える！', start: '2026-04-07' },
        { label: 'メール作成不要！ステップ入力で簡単！', start: '2026-04-19' }
      ],
      now: new Date(),
      // コンビニプリントCTA Impression トラッキング用
      eprintCtaImpressionTracked: false,
      eprintCtaObserver: null
    }
  },
  created: function () {
    const nowdate = new Date()
    const date1 = new Date('2023/09/29 00:00:00')
    const date2 = new Date('2023/10/06 23:59:59')
    if (nowdate > date1 && nowdate < date2) {
      this.isWeekEndFlag = true
    } else {
      this.isWeekEndFlag = false
    }
    const date21 = new Date('2023/11/01 12:00:00')
    const date22 = new Date('2023/11/07 18:00:00')
    if (nowdate > date21 && nowdate < date22) {
      this.isMaint = true
    } else {
      this.isMaint = false
    }

    const nowdate2 = new Date()
    const date12 = new Date('2024/05/05 00:00:00')
    const enddate = new Date('2024/05/30 00:00:00')
    const enddate2 = new Date('2124/05/17 00:00:00')
    /* 日時の差をミリ秒単位で取得 */
    const diffMilliSec = nowdate2 - date12
    /* ミリ秒を日数に変換 */
    const diffDays = parseInt(diffMilliSec / 1000 / 60 / 60 / 24)

    if (diffDays % 2 == 0) {
      this.abtest = 1
    } else {
      this.abtest = 2
    }

    const qmdate1 = new Date('2024/05/30 00:00:00')
    const qmdate2 = new Date('2024/06/06 00:00:00')
    const qmdate3 = new Date('2024/06/13 00:00:00')
    const qmdate4 = new Date('2024/06/20 00:00:00')
    if (nowdate >= qmdate1 && nowdate <= qmdate2) {
      this.qmailBtnLabel = '郵送を依頼'
    } else if (nowdate >= qmdate2 && nowdate <= qmdate3) {
      this.qmailBtnLabel = '配達依頼'
    } else if (nowdate >= qmdate3 && nowdate <= qmdate4) {
      this.qmailBtnLabel = '郵送を依頼'
    } else if (nowdate >= qmdate4) {
      this.qmailBtnLabel = '配達依頼'
    }
    this.qmailBtnLabel = '大切な履歴書を郵送してもらう'

    // }

    // this.abtest = 0

    if (diffMilliSec < 0) {
      console.error(this.qemailBtnLabels[diffDays])
    } else if (diffDays > 4) {
      const _idx = diffDays % 5
      // console.error(_idx)
      // console.error(this.qemailBtnLabels[_idx])
      this.qemailBtnLabel = this.qemailBtnLabels[_idx]
    } else {
      // console.error(this.qemailBtnLabels[diffDays])
      this.qemailBtnLabel = this.qemailBtnLabels[diffDays]
    }
    const dayOfWeek = nowdate.getDay()
    const dayOfWeekStr = ['日', '月', '火', '水', '木', '金', '土'][dayOfWeek]
  },
  computed: {
    getMode: function () {
      return process.env.VUE_APP_MODE
    },
    currentImageUrl () {
      // 1) 文字列 'YYYY-MM-DD' をローカル Date に変換
      const parseLocalYmd = (ymd) => {
        const [y, m, d] = ymd.split('-').map(Number)
        return new Date(y, m - 1, d)
      }
      // 2) Date -> YYYYMMDD の数値キー（時刻無視で比較）
      const dateKey = (date) => {
        const y = date.getFullYear()
        const m = String(date.getMonth() + 1).padStart(2, '0')
        const d = String(date.getDate()).padStart(2, '0')
        return Number(`${y}${m}${d}`)
      }

      const todayKey = dateKey(this.now)

      // 3) 開始日が today 以下のものを抽出し、その中で最も遅い開始日を選ぶ
      const eligible = this.imageRules
        .map(rule => ({ ...rule, startDate: parseLocalYmd(rule.start), startKey: dateKey(parseLocalYmd(rule.start)) }))
        .filter(rule => rule.startKey <= todayKey)
        .sort((a, b) => b.startKey - a.startKey) // 遅い開始日を優先

      // 4) 該当がなければ最初の画像（またはプレースホルダー）を返す
      return eligible.length > 0 ? eligible[0].image : this.imageRules[0].image
    },
    currentTextLabel () {
      // 1) 文字列 'YYYY-MM-DD' をローカル Date に変換
      const parseLocalYmd = (ymd) => {
        const [y, m, d] = ymd.split('-').map(Number)
        return new Date(y, m - 1, d)
      }
      // 2) Date -> YYYYMMDD の数値キー（時刻無視で比較）
      const dateKey = (date) => {
        const y = date.getFullYear()
        const m = String(date.getMonth() + 1).padStart(2, '0')
        const d = String(date.getDate()).padStart(2, '0')
        return Number(`${y}${m}${d}`)
      }

      const todayKey = dateKey(this.now)

      // 3) 開始日が today 以下のものを抽出し、その中で最も遅い開始日を選ぶ
      const eligible = this.labelRules
        .map(rule => ({ ...rule, startDate: parseLocalYmd(rule.start), startKey: dateKey(parseLocalYmd(rule.start)) }))
        .filter(rule => rule.startKey <= todayKey)
        .sort((a, b) => b.startKey - a.startKey) // 遅い開始日を優先

      // 4) 該当がなければ最初の画像（またはプレースホルダー）を返す
      return eligible.length > 0 ? eligible[0].label : this.labelRules[0].label
    }
  },
  watch: {
    // propの変更を監視してローカル状態を同期
    isSendYagiEmailEnabled: {
      handler (newVal) {
        this.localIsSendYagiEmailEnabled = newVal
      },
      immediate: true
    }
    // isAgree: {
    //   handler(newVal) {
    //     console.error("setRoxxsetRoxxse isAgree tRoxxsetRoxxsetRoxxsetRoxx")
    //     this.$globalVar.isRoxx4Rtable = newVal
    //     console.error(this.$globalVar.isRoxx4Rtable)
    //     console.error("setRoxxsetRoxxset isAgree RoxxsetRoxxsetRoxxsetRoxx")
    //   },
    //   immediate: true

    // }
  },
  methods: {
    alertMaint: function () {
      this.$message({
        message: '以下の日時においてヤギの宅配便サービスの休止を行います。【利用一時休止期間】11/1 12:00 〜  11/7 18:00',
        type: 'error'
      })
    },
    handleAutoRt (rtconditions, basicData, formatId, formatData, otherFormatData) {
      this.checkAutoRT(rtconditions, basicData, formatId, formatData, otherFormatData)
      if (this.$globalVar.isAutoRTable) {
        this.$globalVar.isAutoRT4Rtable = !!this.isAgree
      }
    },
    onRtAgreeChange () {
      this.$globalVar.isAutoRT4Rtable = !!this.isAgree
    },
    handleUpdateRtCondition (clientId, permissionType, isSended, dialogName) {
      if (isSended === false && dialogName === 'auto_rt') {
        return
      }

      const info = this.$globalVar.autoRTInfo
      if (!info || !info.clientId) {
        return
      }

      if (String(info.clientId) !== String(clientId)) {
        return
      }

      const hasPermissionType = permissionType !== undefined && permissionType !== null
      const matchedPermission = !hasPermissionType ||
        Number(info.permissionType) === Number(permissionType) ||
        Number(info.oldPermissionType) === Number(permissionType)

      if (!matchedPermission) {
        return
      }

      // 同一 update_rt_condition イベント内では FormatEdit 側のペア判定に autoRTInfo を使うため、
      // クリアは次ティックに遅延して順序競合を回避する。
      this.$nextTick(() => {
        this.$globalVar.autoRTInfo = {
          logoImage: '',
          clientId: '',
          dialogName: '',
          clientName: '',
          termurl: '',
          privacyurl: '',
          occupationurl: '',
          handlingurl: '',
          clientServiceName: '',
          privacyLabel: '',
          showTrailingBr: false,
          permissionType: 0,
          oldPermissionType: 0
        }
      })
    },
    openDialogWithLogin (key) {
      console.log(key)
    },
    // ヤギメール送信ボタンクリック時の処理
    handleYagiEmailClick (eventName, formatId) {
      // ログイン状態をチェック
      if (!this.$firebase.isAuthenticated) {
        // ログインしていない場合は、イベント情報を保存してログインポップアップを表示
        this.pendingYagiEmailEvent = { eventName, formatId }
        this.$eventHub.$emit('open-login-dialog')
        return
      }

      // ログイン済みの場合は既存の処理を実行
      this.executeYagiEmailEvent(eventName, formatId)
    },

    // ヤギメールイベントを実行する共通処理
    executeYagiEmailEvent (eventName, formatId) {
      // ローカル状態を無効化
      this.localIsSendYagiEmailEnabled = false
      // 親コンポーネントに状態変更を通知
      this.$emit('update:isSendYagiEmailEnabled', false)
      // イベントを発火
      this.$eventHub.$emit(eventName, formatId)
    },

    // 汎用的なイベント処理メソッド（ログインチェック付き）
    handleEventWithLoginCheck (eventName, additionalParams = {}) {
      // ログイン状態をチェック
      if (!this.$firebase.isAuthenticated) {
        // ログインしていない場合は、イベント情報を保存してログインポップアップを表示
        this.pendingEvent = { eventName, additionalParams }
        this.$eventHub.$emit('open-login-dialog')
        return
      }

      // ログイン済みの場合はイベントを実行
      this.executeEvent(eventName, additionalParams)
    },

    // イベントを実行する共通処理
    executeEvent (eventName, additionalParams = {}) {
      // コンビニプリントCTAクリック時のイベント送信
      if (eventName === 'show-preview-4conv') {
        this.$gtm.sendEprintEvent('cta_click', {
          format_id: this.formatId,
          click_location: 'download_item'
        })
      }

      // send-email-verificationの場合は、メール認証状態を判定して適切なイベントを実行
      if (eventName === 'send-email-verification') {
        this.mailPdfEnabled = false

        // メール認証済みの場合はPDF送信、未認証の場合は認証メール送信
        if (this.$firebase.user && this.$firebase.user.emailVerified) {
          this.$eventHub.$emit('mail-PDF', additionalParams)
        } else {
          this.$eventHub.$emit('send-email-verification', additionalParams)
        }
        return
      }

      // その他のイベントの状態変更処理
      if (eventName === 'mail-PDF') {
        this.mailPdfEnabled = false
      } else if (eventName === 'download-PDF') {
        this.downloadPdfEnabled = false
      }

      // イベントを発火
      this.$eventHub.$emit(eventName, additionalParams)
    },

    // ログイン成功時の処理
    handleLoginSuccess () {
      // 保留されているヤギメールイベントがある場合は実行
      if (this.pendingYagiEmailEvent) {
        const { eventName, formatId } = this.pendingYagiEmailEvent
        this.executeYagiEmailEvent(eventName, formatId)
        // 保留イベントをクリア
        this.pendingYagiEmailEvent = null
      }

      // 保留されている一般的なイベントがある場合は実行
      if (this.pendingEvent) {
        const { eventName, additionalParams } = this.pendingEvent
        this.executeEvent(eventName, additionalParams)
        // 保留イベントをクリア
        this.pendingEvent = null
      }
    },

    checkAutoRT (rtconditions, basicData, formatId, formatData, otherFormatData) {
      this.$globalVar.initAutoRT()

      let args = [rtconditions, basicData, formatId, formatData, otherFormatData]

      if (this.$globalVar.isShokumukeirekiFormat(formatId)) {
        args = [rtconditions, basicData, formatId, otherFormatData, formatData]
      }
      const autoRt = useDownloadItemAutoRt(this)

      if (this.$globalVar.isJobChangeFormat(formatId) && autoRt.setPharmate(...args, 2, 1)) {
        this.$globalVar.autoRTInfo = {
          logoImage: '/static/renew3_img/rt/pharmate_1_yagish_logo.png',
          clientId: 'pharmate_mail',
          dialogName: 'auto_rt',
          clientName: '株式会社ファル・メイト',
          termurl: 'https://www.pharmate.jp/policy/',
          privacyurl: 'https://www.pharmate.jp/policy/',
          occupationurl: '',
          clientServiceName: 'Phar+Mate',
          privacyLabel: '個人情報の取り扱いについて',
          showTrailingBr: true,
          permissionType: 2,
          oldPermissionType: 1
        }
        return
      }
      if (this.$globalVar.isJobChangeFormat(formatId) && autoRt.setRecruitMc(...args)) {
        this.$globalVar.autoRTInfo = {
          logoImage: '/static/renew2_img/recruit_mc_1_yagish_log_20231023.png',
          clientId: 'recruit_mc_mail',
          dialogName: 'auto_rt',
          clientName: '(株)リクルートメディカルキャリア',
          termurl: 'https://cdn.p.recruit.co.jp/terms/ryz-t-1001/index.html',
          privacyurl: 'https://cdn.p.recruit.co.jp/terms/cmn-t-1002/index.html',
          occupationurl: '',
          clientServiceName: 'リクナビ薬剤師',
          privacyLabel: 'プライバシーポリシー',
          showTrailingBr: true,
          permissionType: 3,
          oldPermissionType: 1
        }
        return
      }
      if (this.$globalVar.isJobChangeShokumukeirekiFormat(formatId) && autoRt.setXMile(...args, 29, 28)) {
        this.$globalVar.autoRTInfo = {
          logoImage: '/static/renew3_img/rt/xmile_28_yagish_logo.png',
          clientId: 'xmile_mail',
          dialogName: 'auto_rt',
          clientName: 'X Mile株式会社',
          termurl: 'https://www.xmile.co.jp/policy/08',
          privacyurl: 'https://www.xmile.co.jp/policy/06',
          occupationurl: '',
          clientServiceName: 'クロスワーク',
          privacyLabel: '個人情報の取り扱いについて',
          showTrailingBr: true,
          permissionType: 29,
          oldPermissionType: 28
        }
        return
      }
      if (this.$globalVar.isJobChangeFormat(formatId) && autoRt.setAutoRT(...args, 10, 1, 'jobs919_mail')) {
        this.$globalVar.autoRTInfo = {
          logoImage: '/static/renew2_img/919kensetsu_yagish_logo_20230810.png',
          clientId: 'jobs919_mail',
          dialogName: 'auto_rt',
          clientName: '(株)クイック',
          termurl: 'https://plant.ten-navi.com/ruleprivacy/',
          privacyurl: 'https://plant.ten-navi.com/ruleprivacy/',
          occupationurl: '',
          clientServiceName: '建設・設備求人データベース',
          permissionType: 10,
          oldPermissionType: 1
        }
        return
      }
      if (this.$globalVar.isJobChangeFormat(formatId) && autoRt.setAutoRT(...args, 6, 2, 'recree_mail')) {
        this.$globalVar.autoRTInfo = {
          logoImage: '/static/renew2_img/recree_yagish_logo_20240421.png',
          clientId: 'recree_mail',
          dialogName: 'auto_rt',
          clientName: '株式会社レクリー',
          termurl: 'https://recree.jobree.co.jp/terms',
          privacyurl: 'https://recree.jobree.co.jp/privacy_policy',
          occupationurl: '',
          clientServiceName: 'ジョブリー建設',
          permissionType: 6,
          oldPermissionType: 2
        }
        return
      }
      if (this.$globalVar.isJobChangeShokumukeirekiFormat(formatId) && autoRt.setXMile(...args, 30, 5)) {
        this.$globalVar.autoRTInfo = {
          logoImage: '/static/renew3_img/rt/xmile_5_yagish_logo.png',
          clientId: 'xmile_mail',
          dialogName: 'auto_rt',
          clientName: 'X Mile株式会社',
          termurl: 'https://www.xmile.co.jp/policy/08',
          privacyurl: 'https://www.xmile.co.jp/policy/06',
          occupationurl: '',
          clientServiceName: 'クロスワーク',
          privacyLabel: '個人情報の取り扱いについて',
          showTrailingBr: true,
          permissionType: 30,
          oldPermissionType: 5
        }
        return
      }
      if (this.$globalVar.isJobChangeShokumukeirekiFormat(formatId) && autoRt.setXMile(...args, 31, 26)) {
        this.$globalVar.autoRTInfo = {
          logoImage: '/static/renew3_img/rt/xmile_26_yagish_logo.png',
          clientId: 'xmile_mail',
          dialogName: 'auto_rt',
          clientName: 'X Mile株式会社',
          termurl: 'https://www.xmile.co.jp/policy/08',
          privacyurl: 'https://www.xmile.co.jp/policy/06',
          occupationurl: '',
          clientServiceName: 'クロスワーク',
          privacyLabel: '個人情報の取り扱いについて',
          showTrailingBr: true,
          permissionType: 31,
          oldPermissionType: 26
        }
        return
      }
      if (this.$globalVar.isJobChangeShokumukeirekiFormat(formatId) && autoRt.setXMile(...args, 32, 20)) {
        this.$globalVar.autoRTInfo = {
          logoImage: '/static/renew3_img/rt/xmile_20_yagish_logo.png',
          clientId: 'xmile_mail',
          dialogName: 'auto_rt',
          clientName: 'X Mile株式会社',
          termurl: 'https://www.xmile.co.jp/policy/08',
          privacyurl: 'https://www.xmile.co.jp/policy/06',
          occupationurl: '',
          clientServiceName: 'クロスワーク',
          privacyLabel: '個人情報の取り扱いについて',
          showTrailingBr: true,
          permissionType: 32,
          oldPermissionType: 20
        }
        return
      }
      if (this.$globalVar.isJobChangeShokumukeirekiFormat(formatId) && autoRt.setXMile(...args, 33, 8)) {
        this.$globalVar.autoRTInfo = {
          logoImage: '/static/renew3_img/rt/xmile_8_yagish_logo.png',
          clientId: 'xmile_mail',
          dialogName: 'auto_rt',
          clientName: 'X Mile株式会社',
          termurl: 'https://www.xmile.co.jp/policy/08',
          privacyurl: 'https://www.xmile.co.jp/policy/06',
          occupationurl: '',
          clientServiceName: 'クロスワーク',
          privacyLabel: '個人情報の取り扱いについて',
          showTrailingBr: true,
          permissionType: 33,
          oldPermissionType: 8
        }
        return
      }
      if (this.$globalVar.isJobChangeShokumukeirekiFormat(formatId) && autoRt.setXMile(...args, 34, 6)) {
        this.$globalVar.autoRTInfo = {
          logoImage: '/static/renew3_img/rt/xmile_6_yagish_logo.png',
          clientId: 'xmile_mail',
          dialogName: 'auto_rt',
          clientName: 'X Mile株式会社',
          termurl: 'https://www.xmile.co.jp/policy/08',
          privacyurl: 'https://www.xmile.co.jp/policy/06',
          occupationurl: '',
          clientServiceName: 'クロスワーク',
          privacyLabel: '個人情報の取り扱いについて',
          showTrailingBr: true,
          permissionType: 34,
          oldPermissionType: 6
        }
        return
      }
      if (this.$globalVar.isJobChangeShokumukeirekiFormat(formatId) && autoRt.setXMile(...args, 35, 7)) {
        this.$globalVar.autoRTInfo = {
          logoImage: '/static/renew3_img/rt/xmile_7_yagish_logo.png',
          clientId: 'xmile_mail',
          dialogName: 'auto_rt',
          clientName: 'X Mile株式会社',
          termurl: 'https://www.xmile.co.jp/policy/08',
          privacyurl: 'https://www.xmile.co.jp/policy/06',
          occupationurl: '',
          clientServiceName: 'クロスワーク',
          privacyLabel: '個人情報の取り扱いについて',
          showTrailingBr: true,
          permissionType: 35,
          oldPermissionType: 7
        }
        return
      }
      if (this.$globalVar.isJobChangeShokumukeirekiFormat(formatId) && autoRt.setXMile(...args, 36, 16)) {
        this.$globalVar.autoRTInfo = {
          logoImage: '/static/renew3_img/rt/xmile_16_yagish_logo.png',
          clientId: 'xmile_mail',
          dialogName: 'auto_rt',
          clientName: 'X Mile株式会社',
          termurl: 'https://www.xmile.co.jp/policy/08',
          privacyurl: 'https://www.xmile.co.jp/policy/06',
          occupationurl: '',
          clientServiceName: 'クロスワーク',
          privacyLabel: '個人情報の取り扱いについて',
          showTrailingBr: true,
          permissionType: 36,
          oldPermissionType: 16
        }
        return
      }
      if (this.$globalVar.isJobChangeShokumukeirekiFormat(formatId) && autoRt.setXMile(...args, 37, 17)) {
        this.$globalVar.autoRTInfo = {
          logoImage: '/static/renew3_img/rt/xmile_17_yagish_logo.png',
          clientId: 'xmile_mail',
          dialogName: 'auto_rt',
          clientName: 'X Mile株式会社',
          termurl: 'https://www.xmile.co.jp/policy/08',
          privacyurl: 'https://www.xmile.co.jp/policy/06',
          occupationurl: '',
          clientServiceName: 'クロスワーク',
          privacyLabel: '個人情報の取り扱いについて',
          showTrailingBr: true,
          permissionType: 37,
          oldPermissionType: 17
        }
        return
      }
      if (this.$globalVar.isJobChangeFormat(formatId) && autoRt.setAutoRT(...args, 11, 7, 'jobs919_mail')) {
        this.$globalVar.autoRTInfo = {
          logoImage: '/static/renew2_img/919kensetsu_yagish_logo_20230810.png',
          clientId: 'jobs919_mail',
          dialogName: 'auto_rt',
          clientName: '(株)クイック',
          termurl: 'https://plant.ten-navi.com/ruleprivacy/',
          privacyurl: 'https://plant.ten-navi.com/ruleprivacy/',
          occupationurl: '',
          clientServiceName: '建設・設備求人データベース',
          permissionType: 11,
          oldPermissionType: 7
        }
        return
      }
      if (this.$globalVar.isJobChangeFormat(formatId) && autoRt.setAutoRT(...args, 12, 2, 'jobs919_mail')) {
        this.$globalVar.autoRTInfo = {
          logoImage: '/static/renew2_img/919jobs_yagish_logo_20230810.png',
          clientId: 'jobs919_mail',
          dialogName: 'auto_rt',
          clientName: '(株)クイック',
          termurl: 'https://plant.ten-navi.com/ruleprivacy/',
          privacyurl: 'https://plant.ten-navi.com/ruleprivacy/',
          occupationurl: '',
          clientServiceName: '整備士JOBS',
          permissionType: 12,
          oldPermissionType: 3
        }
        return
      }
      if (this.$globalVar.isJobChangeFormat(formatId) && autoRt.setAutoRT(...args, 13, 8, 'jobs919_mail')) {
        this.$globalVar.autoRTInfo = {
          logoImage: '/static/renew2_img/919jobs_yagish_logo_20230810.png',
          clientId: 'jobs919_mail',
          dialogName: 'auto_rt',
          clientName: '(株)クイック',
          termurl: 'https://plant.ten-navi.com/ruleprivacy/',
          privacyurl: 'https://plant.ten-navi.com/ruleprivacy/',
          occupationurl: '',
          clientServiceName: '整備士JOBS',
          permissionType: 13,
          oldPermissionType: 8
        }
        return
      }
      if (this.$globalVar.isJobChangeFormat(formatId) && autoRt.setAutoRT(...args, 14, 9, 'jobs919_mail')) {
        this.$globalVar.autoRTInfo = {
          logoImage: '/static/renew2_img/919jobs_yagish_logo_20230810.png',
          clientId: 'jobs919_mail',
          dialogName: 'auto_rt',
          clientName: '(株)クイック',
          termurl: 'https://plant.ten-navi.com/ruleprivacy/',
          privacyurl: 'https://plant.ten-navi.com/ruleprivacy/',
          occupationurl: '',
          clientServiceName: '整備士JOBS',
          permissionType: 14,
          oldPermissionType: 9
        }
        return
      }
      if (this.$globalVar.isJobChangeFormat(formatId) && autoRt.setAutoRT(...args, 15, 4, 'jobs919_mail')) {
        this.$globalVar.autoRTInfo = {
          logoImage: '/static/renew2_img/919kensetsu_yagish_logo_20230810.png',
          clientId: 'jobs919_mail',
          dialogName: 'auto_rt',
          clientName: '(株)クイック',
          termurl: 'https://plant.ten-navi.com/ruleprivacy/',
          privacyurl: 'https://plant.ten-navi.com/ruleprivacy/',
          occupationurl: '',
          clientServiceName: '建設・設備求人データベース',
          permissionType: 15,
          oldPermissionType: 4
        }
        return
      }

      if (this.$globalVar.isJobChangeFormat(formatId) && autoRt.setAutoRT(...args, 7, 2, 'plexjob_mail')) {
        this.$globalVar.autoRTInfo = {
          logoImage: '/static/renew3_img/rt/plexjob_1_yagish_logo.png',
          clientId: 'plexjob_mail',
          dialogName: 'plexjob-dialog',
          clientName: '株式会社プレックス',
          termurl: 'https://www.plex-job.com/terms/',
          privacyurl: 'https://www.plex-job.com/privacy-policy/',
          occupationurl: '',
          clientServiceName: 'PLEX JOB',
          permissionType: 7,
          oldPermissionType: 2
        }
        return
      }
      if (this.$globalVar.isJobChangeFormat(formatId) && autoRt.setAutoRT(...args, 5, 4, 'tryt_api')) {
        this.$globalVar.autoRTInfo = {
          logoImage: '/static/renew3_img/rt/tryt_4_yagish_logo.png',
          clientId: 'tryt_api',
          dialogName: 'tryt-dialog',
          clientName: '株式会社トライトキャリア',
          termurl: 'https://iryouworker.com/company/sitepolicy/',
          privacyurl: 'https://iryouworker.com/company/privacypolicy/',
          handlingurl: 'https://iryouworker.com/company/handling/',
          clientServiceName: '看護師ワーカー',
          occupationurl: '',
          permissionType: 5,
          oldPermissionType: 4
        }
        return
      }
      if (this.$globalVar.isNewFormat(formatId) && autoRt.setNeocareer(...args)) {
        this.$globalVar.autoRTInfo = {
          logoImage: '/static/renew2_img/neoe_yagish_logo_20230704.png',
          clientId: 'neocareer_admin',
          dialogName: 'auto_rt',
          clientName: '(株)ネオキャリア',
          termurl: 'https://www.s-agent.jp/agreement',
          privacyurl: 'https://www.neo-career.co.jp/policy/',
          occupationurl: '',
          clientServiceName: '就職Agent neo',
          privacyLabel: '個人情報の取り扱いについて',
          showTrailingBr: true,
          permissionType: 4,
          oldPermissionType: 1
        }
        return
      }
      // per6はper4と同じ auto-rt（per5・per6 両方 request_able で per6 にアップグレード）
      if (this.$globalVar.isNewFormat(formatId) && autoRt.setAutoRT(...args, 6, 5, 'neocareer_admin')) {
        this.$globalVar.autoRTInfo = {
          logoImage: '/static/renew2_img/neoe_yagish_logo_20230704.png',
          clientId: 'neocareer_admin',
          dialogName: 'auto_rt',
          clientName: '(株)ネオキャリア',
          termurl: 'なし',
          privacyurl: 'なし',
          occupationurl: '',
          clientServiceName: '就職Agent neo',
          permissionType: 6,
          oldPermissionType: 5
        }
        return
      }
      if (this.$globalVar.isNewFormat(formatId) && autoRt.setAutoRTNewOnly(...args, 8, 'terracia_mail')) {
        this.$globalVar.autoRTInfo = {
          logoImage: '/static/renew3_img/rt/terracia_1_yagish_logo.png',
          clientId: 'terracia_mail',
          dialogName: 'auto_rt',
          clientName: '株式会社テラシア',
          termurl: 'https://terracia-web.com/terms-of-service/',
          privacyurl: 'https://terracia-web.com/privacypolicy/',
          occupationurl: '',
          clientServiceName: '保育士テラス',
          permissionType: 8
        }

        return
      }
      if (this.$globalVar.isNewFormat(formatId) && autoRt.setAutoRT(...args, 2, 1, 'hrteam_mail')) {
        this.$globalVar.autoRTInfo = {
          logoImage: '/static/renew3_img/rt/hrteam_1_yagish_logo.png',
          clientId: 'hrteam_mail',
          dialogName: 'auto_rt',
          clientName: '株式会社HRteam',
          termurl: 'https://hr-team.co.jp/commit-terms/',
          privacyurl: 'https://hr-team.co.jp/privacy/',
          occupationurl: '',
          clientServiceName: 'ジョブコミット新卒',
          permissionType: 2,
          oldPermissionType: 1
        }

        return
      }
      if (this.$globalVar.isNewFormat(formatId) && autoRt.setAutoRT(...args, 4, 3, 'careerdraft_mail')) {
        this.$globalVar.autoRTInfo = {
          logoImage: '/static/renew3_img/rt/careerdraft_3_yagish_logo.png',
          clientId: 'careerdraft_mail',
          dialogName: 'auto_rt',
          clientName: '絆ホールディングス(株)',
          termurl: 'https://d27rnpuamwvieu.cloudfront.net/pdf/0nvXg8Nheikk1vyMiwjjlMQXX.pdf',
          privacyurl: 'https://d27rnpuamwvieu.cloudfront.net/pdf/0J67ChgX0gawBQYVnQiXVSwXX.pdf',
          occupationurl: '',
          clientServiceName: 'キャリアドラフト',
          permissionType: 4,
          oldPermissionType: 3
        }
        return
      }

      if (this.$globalVar.isNewFormat(formatId) && autoRt.setAutoRTNewOnly(...args, 2, 'cmindcareer_mail')) {
        this.$globalVar.autoRTInfo = {
          logoImage: '/static/renew3_img/rt/cmindcareer_1_yagish_logo.png',
          clientId: 'cmindcareer_mail',
          dialogName: 'auto_rt',
          clientName: '株式会社シーマインドキャリア',
          termurl: 'https://cmindcareer.co.jp/privacy/',
          privacyurl: 'https://cmindcareer.co.jp/privacy/',
          occupationurl: '',
          clientServiceName: 'シーマインドキャリア',
          permissionType: 2
        }
        return
      }

      if (this.$globalVar.isJobChangeFormat(formatId) && autoRt.setAutoRT(...args, 23, 5, 'medley_link')) {
        this.$globalVar.autoRTInfo = {
          logoImage: '/static/renew3_img/rt/job-medley-yagish-logo-20241119.png',
          clientId: 'medley_link',
          dialogName: 'auto_rt',
          clientName: '株式会社メドレー',
          termurl: 'https://job-medley.com/rule/',
          privacyurl: 'https://job-medley.com/rule/',
          occupationurl: '',
          clientServiceName: 'ジョブメドレー',
          permissionType: 23,
          oldPermissionType: 5
        }
        return
      }
      if (this.$globalVar.isJobChangeShokumukeirekiFormat(formatId) && autoRt.setAutoRTNewOnly(...args, 19, 'pleiades_mail')) {
        this.$globalVar.autoRTInfo = {
          logoImage: '/static/renew2_img/pleiades_yagish_logo_2.png',
          clientId: 'pleiades_mail',
          dialogName: 'auto_rt',
          clientName: '株式会社プレアデス',
          termurl: 'https://www.pleiades-net.co.jp/privacy/',
          privacyurl: 'https://www.pleiades-net.co.jp/privacy/',
          occupationurl: '',
          clientServiceName: '株式会社プレアデス',
          permissionType: 19,
          oldPermissionType: 2
        }
        return
      }
      if (this.$globalVar.isJobChangeShokumukeirekiFormat(formatId) && autoRt.setAutoRTNewOnly(...args, 20, 'pleiades_mail')) {
        this.$globalVar.autoRTInfo = {
          logoImage: '/static/renew2_img/pleiades_yagish_logo_567.png',
          clientId: 'pleiades_mail',
          dialogName: 'auto_rt',
          clientName: '株式会社プレアデス',
          termurl: 'https://www.pleiades-net.co.jp/privacy/',
          privacyurl: 'https://www.pleiades-net.co.jp/privacy/',
          occupationurl: '',
          clientServiceName: '株式会社プレアデス',
          permissionType: 20,
          oldPermissionType: 12
        }
        return
      }
      if (this.$globalVar.isJobChangeShokumukeirekiFormat(formatId) && autoRt.setAutoRT(...args, 6, 1, 'nineearth_mail')) {
        this.$globalVar.autoRTInfo = {
          logoImage: '/static/renew3_img/rt/nineearth_1_yagish_logo.png',
          clientId: 'nineearth_mail',
          dialogName: 'auto_rt',
          clientName: '株式会社N.E',
          termurl: 'https://nine-earth.co.jp/kaigo_s2/terms.html',
          privacyurl: 'https://nine-earth.co.jp/kaigo_s2/privacy.html',
          occupationurl: '',
          clientServiceName: '介護ナイン',
          permissionType: 6,
          oldPermissionType: 1
        }
        return
      }
      if (this.$globalVar.isJobChangeShokumukeirekiFormat(formatId) && autoRt.setAutoRT(...args, 7, 2, 'nineearth_mail')) {
        this.$globalVar.autoRTInfo = {
          logoImage: '/static/renew3_img/rt/nineearth_2_yagish_logo.png',
          clientId: 'nineearth_mail',
          dialogName: 'auto_rt',
          clientName: '株式会社N.E',
          termurl: 'https://nine-earth.co.jp/kaigo_s2/terms.html',
          privacyurl: 'https://nine-earth.co.jp/kaigo_s2/privacy.html',
          occupationurl: '',
          clientServiceName: '介護ナイン',
          permissionType: 7,
          oldPermissionType: 2
        }
        return
      }
      if (this.$globalVar.isJobChangeShokumukeirekiFormat(formatId) && autoRt.setAutoRT(...args, 8, 5, 'nineearth_mail')) {
        this.$globalVar.autoRTInfo = {
          logoImage: '/static/renew3_img/rt/nineearth_5_yagish_logo.png',
          clientId: 'nineearth_mail',
          dialogName: 'auto_rt',
          clientName: '株式会社N.E',
          termurl: 'https://nine-earth.co.jp/kaigo_s2/terms.html',
          privacyurl: 'https://nine-earth.co.jp/kaigo_s2/privacy.html',
          occupationurl: '',
          clientServiceName: '看護ナイン',
          permissionType: 8,
          oldPermissionType: 5
        }
        return
      }
      if (this.$globalVar.isJobChangeFormat(formatId) && autoRt.setAutoRTNewOnly(...args, 6, 'peacekaigo_mail')) {
        this.$globalVar.autoRTInfo = {
          logoImage: '/static/renew2_img/peacekaigo_yagish_logo_4.png',
          clientId: 'peacekaigo_mail',
          dialogName: 'auto_rt',
          clientName: 'ネクストイノベーション',
          termurl: 'https://peace-kango.com/terms/',
          privacyurl: 'https://peace-kango.com/company/privacy_policy/',
          occupationurl: '',
          clientServiceName: 'ネクストイノベーション',
          permissionType: 6,
          oldPermissionType: 5
        }
        return
      }
      if (this.$globalVar.isJobChangeShokumukeirekiFormat(formatId) && autoRt.setAutoRT(...args, 2, 1, 'kikkakeagent_mail')) {
        this.$globalVar.autoRTInfo = {
          logoImage: '/static/renew3_img/rt/kikkakeagent_yagish_logo_20250326.png',
          clientId: 'kikkakeagent_mail',
          dialogName: 'auto_rt',
          clientName: '株式会社キッカケクリエイション',
          termurl: 'https://kikkakeagent.co.jp/term-of-service',
          privacyurl: 'https://kikkakecreation.com/privacy/',
          occupationurl: '',
          clientServiceName: 'キッカケクリエイション_ITエンジニア',
          permissionType: 2,
          oldPermissionType: 1
        }
        return
      }
      if (this.$globalVar.isJobChangeShokumukeirekiFormat(formatId) && autoRt.setRoxx(...args)) {
        this.$globalVar.autoRTInfo = {
          logoImage: '/static/renew2_img/zcareer-roxx-yagish-logo.png',
          clientId: 'roxx_api',
          dialogName: 'auto_rt',
          clientName: 'Zキャリア エージェント',
          termurl: 'https://agent.zcareer.com/terms/',
          privacyurl: 'https://roxx.co.jp/policy/privacy',
          occupationurl: '',
          clientServiceName: 'Zキャリア エージェント',
          privacyLabel: '個人情報保護方針',
          showTrailingBr: true,
          permissionType: 10,
          oldPermissionType: 1
        }
        return
      }
      if (this.$globalVar.isNewFormat(formatId) && autoRt.setAutoRT(...args, 12, 11, 'roxx_api')) {
        this.$globalVar.autoRTInfo = {
          logoImage: '/static/renew2_img/zcareer-roxx-yagish-logo.png',
          clientId: 'roxx_api',
          dialogName: 'auto_rt',
          clientName: '株式会社ROXX',
          termurl: 'https://agent.zcareer.com/terms/',
          privacyurl: 'https://roxx.co.jp/policy/privacy',
          occupationurl: '',
          clientServiceName: 'Zキャリア エージェント',
          permissionType: 12
        }
        return
      }
      if (this.$globalVar.isJobChangeShokumukeirekiFormat(formatId) && autoRt.setAutoRTNewOnly(...args, 17, 'roxx_api')) {
        this.$globalVar.autoRTInfo = {
          logoImage: '/static/renew3_img/rt/roxx_13-16_yagish_logo.png',
          clientId: 'roxx_api',
          dialogName: 'auto_rt',
          clientName: '(株)ROXX',
          termurl: 'https://agent.zcareer.com/terms/',
          privacyurl: 'https://roxx.co.jp/policy/privacy',
          occupationurl: '',
          clientServiceName: 'Zキャリア',
          permissionType: 17
        }
        return
      }
      if (this.$globalVar.isJobChangeShokumukeirekiFormat(formatId) && autoRt.setAutoRTNewOnly(...args, 18, 'roxx_api')) {
        this.$globalVar.autoRTInfo = {
          logoImage: '/static/renew3_img/rt/roxx_13-16_yagish_logo.png',
          clientId: 'roxx_api',
          dialogName: 'auto_rt',
          clientName: '(株)ROXX',
          termurl: 'https://agent.zcareer.com/terms/',
          privacyurl: 'https://roxx.co.jp/policy/privacy',
          occupationurl: '',
          clientServiceName: 'Zキャリア',
          permissionType: 18
        }
        return
      }
      if (this.$globalVar.isJobChangeShokumukeirekiFormat(formatId) && autoRt.setAutoRTNewOnly(...args, 19, 'roxx_api')) {
        this.$globalVar.autoRTInfo = {
          logoImage: '/static/renew3_img/rt/roxx_13-16_yagish_logo.png',
          clientId: 'roxx_api',
          dialogName: 'auto_rt',
          clientName: '(株)ROXX',
          termurl: 'https://agent.zcareer.com/terms/',
          privacyurl: 'https://roxx.co.jp/policy/privacy',
          occupationurl: '',
          clientServiceName: 'Zキャリア',
          permissionType: 19
        }
        return
      }
      if (this.$globalVar.isJobChangeShokumukeirekiFormat(formatId) && autoRt.setAutoRTNewOnly(...args, 20, 'roxx_api')) {
        this.$globalVar.autoRTInfo = {
          logoImage: '/static/renew3_img/rt/roxx_13-16_yagish_logo.png',
          clientId: 'roxx_api',
          dialogName: 'auto_rt',
          clientName: '(株)ROXX',
          termurl: 'https://agent.zcareer.com/terms/',
          privacyurl: 'https://roxx.co.jp/policy/privacy',
          occupationurl: '',
          clientServiceName: 'Zキャリア',
          permissionType: 20
        }
        return
      }
      if (this.$globalVar.isNewFormat(formatId) && autoRt.setAutoRT(...args, 2, 1, 'onecareer_mail')) {
        this.$globalVar.autoRTInfo = {
          logoImage: '/static/renew3_img/rt/onecareer_1_yagish_logo.png',
          clientId: 'onecareer_mail',
          dialogName: 'auto_rt',
          clientName: '株式会社ワンキャリア',
          termurl: 'https://www.onecareer.jp/infos/terms',
          privacyurl: 'https://www.onecareer.jp/infos/signup_privacy_policy',
          occupationurl: '',
          clientServiceName: 'ワンキャリア',
          permissionType: 2,
          oldPermissionType: 1
        }
        return
      }
      if (this.$globalVar.isJobChangeShokumukeirekiFormat(formatId) && autoRt.setAutoRT(...args, 7, 1, 'terracia_mail')) {
        this.$globalVar.autoRTInfo = {
          logoImage: '/static/renew3_img/rt/terracia_1_yagish_logo.png',
          clientId: 'terracia_mail',
          dialogName: 'auto_rt',
          clientName: '株式会社テラシア',
          termurl: 'https://terracia-web.com/terms-of-service/',
          privacyurl: 'https://terracia-web.com/privacypolicy/',
          clientServiceName: '保育士テラス',
          permissionType: 7,
          oldPermissionType: 1
        }
        return
      }
      if (this.$globalVar.isJobChangeShokumukeirekiFormat(formatId) && autoRt.setAutoRT(...args, 5, 3, 'terracia_mail')) {
        this.$globalVar.autoRTInfo = {
          logoImage: '/static/renew3_img/rt/terracia_1_yagish_logo.png',
          clientId: 'terracia_mail',
          dialogName: 'auto_rt',
          clientName: '株式会社テラシア',
          termurl: 'https://terracia-web.com/terms-of-service/',
          privacyurl: 'https://terracia-web.com/privacypolicy/',
          occupationurl: '',
          clientServiceName: '保育士テラス',
          permissionType: 5,
          oldPermissionType: 3
        }
        return
      }
      if (this.$globalVar.isJobChangeShokumukeirekiFormat(formatId) && autoRt.setAutoRT(...args, 6, 4, 'terracia_mail')) {
        this.$globalVar.autoRTInfo = {
          logoImage: '/static/renew3_img/rt/terracia_2_yagish_logo.png',
          clientId: 'terracia_mail',
          dialogName: 'auto_rt',
          clientName: '株式会社テラシア',
          termurl: 'https://terracia-web.com/terms-of-service/',
          privacyurl: 'https://terracia-web.com/privacypolicy/',
          occupationurl: '',
          clientServiceName: '保育士テラス',
          permissionType: 6,
          oldPermissionType: 4
        }
        return
      }
      if (this.$globalVar.isJobChangeShokumukeirekiFormat(formatId) && autoRt.setAutoRTNewOnly(...args, 1, 'sms_admin_new')) {
        this.$globalVar.autoRTInfo = {
          logoImage: '/static/renew3_img/rt/sms_kaigo_1_yagish_logo.png',
          clientId: 'sms_admin_new',
          dialogName: 'auto_rt',
          clientName: '株式会社エス･エム･エス_介護',
          termurl: 'https://www.kaigoagent.com/contents/tos.html',
          privacyurl: 'https://www.kaigoagent.com/contents/pmark.html',
          occupationurl: '',
          clientServiceName: 'カイゴジョブエージェント',
          permissionType: 1
        }
        return
      } if (this.$globalVar.isJobChangeShokumukeirekiFormat(formatId) && autoRt.setAutoRTNewOnly(...args, 2, 'sms_admin_new')) {
        this.$globalVar.autoRTInfo = {
          logoImage: '/static/renew3_img/rt/sms_kaigo_2_yagish_logo.png',
          clientId: 'sms_admin_new',
          dialogName: 'auto_rt',
          clientName: '株式会社エス･エム･エス_介護',
          termurl: 'https://www.kaigoagent.com/contents/tos.html',
          privacyurl: 'https://www.kaigoagent.com/contents/pmark.html',
          occupationurl: '',
          clientServiceName: 'カイゴジョブエージェント',
          permissionType: 2
        }
        return
      } if (this.$globalVar.isJobChangeShokumukeirekiFormat(formatId) && autoRt.setAutoRTNewOnly(...args, 3, 'sms_admin_new')) {
        this.$globalVar.autoRTInfo = {
          logoImage: '/static/renew3_img/rt/sms_hoiku_3_yagish_logo.png',
          clientId: 'sms_admin_new',
          dialogName: 'auto_rt',
          clientName: '株式会社エス･エム･エス_保育',
          termurl: 'https://policy.bm-sms.co.jp/consumer/terms/jinzaibank-com',
          privacyurl: 'https://policy.bm-sms.co.jp/consumer/privacy/policy',
          occupationurl: '',
          clientServiceName: '保育士人材バンク',
          permissionType: 3
        }
        return
      } if (this.$globalVar.isJobChangeShokumukeirekiFormat(formatId) && autoRt.setAutoRTNewOnly(...args, 4, 'sms_admin_new')) {
        this.$globalVar.autoRTInfo = {
          logoImage: '/static/renew3_img/rt/sms_hoiku_4_yagish_logo.png',
          clientId: 'sms_admin_new',
          dialogName: 'auto_rt',
          clientName: '株式会社エス･エム･エス_保育',
          termurl: 'https://policy.bm-sms.co.jp/consumer/terms/jinzaibank-com',
          privacyurl: 'https://policy.bm-sms.co.jp/consumer/privacy/policy',
          occupationurl: '',
          clientServiceName: '保育士人材バンク',
          permissionType: 4
        }
        return
      } if (this.$globalVar.isJobChangeShokumukeirekiFormat(formatId) && autoRt.setAutoRTNewOnly(...args, 5, 'sms_admin_new')) {
        this.$globalVar.autoRTInfo = {
          logoImage: '/static/renew3_img/rt/sms_5_yagish_logo.png',
          clientId: 'sms_admin_new',
          dialogName: 'auto_rt',
          clientName: '株式会社エス･エム･エス',
          termurl: 'https://policy.bm-sms.co.jp/consumer/terms/jinzaibank-com',
          privacyurl: 'https://policy.bm-sms.co.jp/consumer/privacy/policy',
          occupationurl: '',
          clientServiceName: 'ナース専科',
          permissionType: 5
        }
        return
      } if (this.$globalVar.isJobChangeShokumukeirekiFormat(formatId) && autoRt.setAutoRTNewOnly(...args, 6, 'sms_admin_new')) {
        this.$globalVar.autoRTInfo = {
          logoImage: '/static/renew3_img/rt/sms_ptot_6_yagish_logo.png',
          clientId: 'sms_admin_new',
          dialogName: 'auto_rt',
          clientName: '株式会社エス･エム･エス_PTOT',
          termurl: 'https://policy.bm-sms.co.jp/consumer/terms/jinzaibank-com',
          privacyurl: 'https://policy.bm-sms.co.jp/consumer/privacy/policy',
          occupationurl: '',
          clientServiceName: 'PTOT人材バンク',
          permissionType: 6
        }
        return
      } if (this.$globalVar.isJobChangeShokumukeirekiFormat(formatId) && autoRt.setAutoRTNewOnly(...args, 7, 'sms_admin_new')) {
        this.$globalVar.autoRTInfo = {
          logoImage: '/static/renew3_img/rt/sms_ptot_7_yagish_logo.png',
          clientId: 'sms_admin_new',
          dialogName: 'auto_rt',
          clientName: '株式会社エス･エム･エス_PTOT',
          termurl: 'https://policy.bm-sms.co.jp/consumer/terms/jinzaibank-com',
          privacyurl: 'https://policy.bm-sms.co.jp/consumer/privacy/policy',
          occupationurl: '',
          clientServiceName: 'PTOT人材バンク',
          permissionType: 7
        }
        return
      } if (this.$globalVar.isJobChangeShokumukeirekiFormat(formatId) && autoRt.setAutoRTNewOnly(...args, 8, 'sms_admin_new')) {
        this.$globalVar.autoRTInfo = {
          logoImage: '/static/renew3_img/rt/sms_ptot_8_yagish_logo.png',
          clientId: 'sms_admin_new',
          dialogName: 'auto_rt',
          clientName: '株式会社エス･エム･エス_PTOT',
          termurl: 'https://policy.bm-sms.co.jp/consumer/terms/jinzaibank-com',
          privacyurl: 'https://policy.bm-sms.co.jp/consumer/privacy/policy',
          occupationurl: '',
          clientServiceName: 'PTOT人材バンク',
          permissionType: 8
        }
        return
      } if (this.$globalVar.isJobChangeShokumukeirekiFormat(formatId) && autoRt.setAutoRTNewOnly(...args, 9, 'sms_admin_new')) {
        this.$globalVar.autoRTInfo = {
          logoImage: '/static/renew3_img/rt/sms_9_yagish_logo.png',
          clientId: 'sms_admin_new',
          dialogName: 'auto_rt',
          clientName: '株式会社エス･エム･エス',
          termurl: 'https://policy.bm-sms.co.jp/consumer/terms/jinzaibank-com',
          privacyurl: 'https://policy.bm-sms.co.jp/consumer/privacy/policy',
          occupationurl: '',
          clientServiceName: '検査技師バンク',
          permissionType: 9
        }
        return
      } if (this.$globalVar.isJobChangeShokumukeirekiFormat(formatId) && autoRt.setAutoRTNewOnly(...args, 10, 'sms_admin_new')) {
        this.$globalVar.autoRTInfo = {
          logoImage: '/static/renew3_img/rt/sms_10_yagish_logo.png',
          clientId: 'sms_admin_new',
          dialogName: 'auto_rt',
          clientName: '株式会社エス･エム･エス',
          termurl: 'https://policy.bm-sms.co.jp/consumer/terms/jinzaibank-com',
          privacyurl: 'https://policy.bm-sms.co.jp/consumer/privacy/policy',
          occupationurl: '',
          clientServiceName: '放射線技師バンク',
          permissionType: 10
        }
        return
      } if (this.$globalVar.isJobChangeShokumukeirekiFormat(formatId) && autoRt.setAutoRTNewOnly(...args, 11, 'sms_admin_new')) {
        this.$globalVar.autoRTInfo = {
          logoImage: '/static/renew3_img/rt/sms_11_yagish_logo.png',
          clientId: 'sms_admin_new',
          dialogName: 'auto_rt',
          clientName: '株式会社エス･エム･エス',
          termurl: 'https://policy.bm-sms.co.jp/consumer/terms/jinzaibank-com',
          privacyurl: 'https://policy.bm-sms.co.jp/consumer/privacy/policy',
          occupationurl: '',
          clientServiceName: '工学技師バンク',
          permissionType: 11
        }
        return
      } if (this.$globalVar.isJobChangeShokumukeirekiFormat(formatId) && autoRt.setAutoRTNewOnly(...args, 12, 'sms_admin_new')) {
        this.$globalVar.autoRTInfo = {
          logoImage: '/static/renew3_img/rt/sms_12_yagish_logo.png',
          clientId: 'sms_admin_new',
          dialogName: 'auto_rt',
          clientName: '株式会社エス･エム･エス',
          termurl: 'https://policy.bm-sms.co.jp/consumer/terms/jinzaibank-com',
          privacyurl: 'https://policy.bm-sms.co.jp/consumer/privacy/policy',
          occupationurl: '',
          clientServiceName: '国試黒本治療家エージェント',
          permissionType: 12
        }
        return
      } if ((formatId === 'rerekisho_part_time' || formatId === 'rirekisho_part_time2') && autoRt.setAutoRTNewOnly(...args, 9, 'terracia_mail')) {
        this.$globalVar.autoRTInfo = {
          logoImage: '/static/renew3_img/rt/terracia_1_yagish_logo.png',
          clientId: 'terracia_mail',
          dialogName: 'auto_rt',
          clientName: '株式会社テラシア',
          termurl: 'https://terracia-web.com/terms-of-service/',
          privacyurl: 'https://terracia-web.com/privacypolicy/',
          occupationurl: '',
          clientServiceName: '保育士テラス',
          permissionType: 9
        }
        return
      } if ((formatId === 'rerekisho_part_time' || formatId === 'rirekisho_part_time2') && autoRt.setAutoRTNewOnly(...args, 10, 'terracia_mail')) {
        this.$globalVar.autoRTInfo = {
          logoImage: '/static/renew3_img/rt/terracia_1_yagish_logo.png',
          clientId: 'terracia_mail',
          dialogName: 'auto_rt',
          clientName: '株式会社テラシア',
          termurl: 'https://terracia-web.com/terms-of-service/',
          privacyurl: 'https://terracia-web.com/privacypolicy/',
          occupationurl: '',
          clientServiceName: '保育士テラス',
          permissionType: 10
        }
        return
      } if (this.$globalVar.isJobChangeShokumukeirekiFormat(formatId) && autoRt.setAutoRT(...args, 2, 1, 'primalwork_mail')) {
        this.$globalVar.autoRTInfo = {
          logoImage: '/static/renew3_img/rt/primalwork_yagish_logo_20250326.jpg',
          clientId: 'primalwork_mail',
          dialogName: 'auto_rt',
          clientName: '株式会社プライマルワーク',
          termurl: 'https://primalwork.net/terms-of-service/',
          privacyurl: 'https://primalwork.net/privacy-policy/',
          occupationurl: '',
          clientServiceName: 'プライマルワーク',
          permissionType: 2,
          oldPermissionType: 1
        }
      }
    }
  },
  beforeMount: function () {
    // ログイン成功イベントをリッスン
    this.$eventHub.$on('login-success', this.handleLoginSuccess)
    // this.$eventHub.$on('roxx-set', this.setRoxx)
    this.$eventHub.$on('auto-rt', this.handleAutoRt)
    this.$eventHub.$on('update_rt_condition', this.handleUpdateRtCondition)
  },
  mounted: function () {
    // コンビニプリントCTAボタンのImpression トラッキング
    this.$nextTick(() => {
      const eprintButtons = this.$el.querySelectorAll('#pdf-eprint-btn')
      if (eprintButtons.length > 0 && 'IntersectionObserver' in window) {
        this.eprintCtaObserver = new IntersectionObserver((entries) => {
          entries.forEach(entry => {
            if (entry.isIntersecting && !this.eprintCtaImpressionTracked) {
              this.eprintCtaImpressionTracked = true
              this.$gtm.sendEprintEvent('cta_impression', {
                format_id: this.formatId,
                impression_location: 'download_item'
              })
              // 一度トラッキングしたらオブザーバーを停止
              if (this.eprintCtaObserver) {
                this.eprintCtaObserver.disconnect()
              }
            }
          })
        }, { threshold: 0.5 })

        // 最初に見つかったCTAボタンのみを監視
        this.eprintCtaObserver.observe(eprintButtons[0])
      }
    })
  },
  destroyed: function () {
    // コンビニプリントCTA Observerの解除
    if (this.eprintCtaObserver) {
      this.eprintCtaObserver.disconnect()
      this.eprintCtaObserver = null
    }
    // イベントリスナーの解除
    this.$eventHub.$off('login-success', this.handleLoginSuccess)
    // this.$eventHub.$off('roxx-set', this.setRoxx)
    this.$eventHub.$off('auto-rt', this.handleAutoRt)
    this.$eventHub.$off('update_rt_condition', this.handleUpdateRtCondition)
  }
}
</script>
